import { piexif } from './piexif';
import CV from './cv';
import jsfeat from './jsfeat';

/**
 * MitekMobileWebAPI - v2.6.1 - 2019-02-14
 * http://www.miteksystems.com/
 *
 * Copyright (c) 2019 MitekSystems
 * Licensed  <http://www.miteksystems.com/>
 */

export default function mitekInit() {
  const mitekWorkerPath = URL.createObjectURL(
    new Blob([`(${window.mitekWorkerFunction.toString()})()`], {
      type: 'text/javascript',
    }),
  );

  if (typeof window.MitekMobileWeb !== 'undefined') {
    return;
  }

  function isMobileDevice() {
    return (
      'undefined' != typeof window.orientation || -1 !== navigator.userAgent.indexOf('IEMobile')
    );
  }
  window.MitekMobileWeb = {
    mitekWorker: null,
    MitekMibiData: {
      MibiVersion: '1.4',
      UserAgent: '',
      Parameters: { MiSnapVersion: 'MobileWeb 2.6.1' },
      MiSnapResultCode: 'SuccessStillCamera',
      ImageSource: {
        Platform: isMobileDevice() ? 'Mobile' : 'Desktop',
        Method: 'captureAndProcessImage',
        Upload: 'false',
      },
      UXP: [],
    },
    initCaptureSession: function (a, b) {
      return (
        MitekMobileWeb.getImageTypeCode(a, !0) != MitekMobileWeb.MitekImageTypeCode.BARCODE_PDF417
          ? ((MitekMobileWeb.MitekCaptureSession.CaptureParams =
              null == b ? MitekMobileWeb.MitekDefaultCaptureParams.StandardCaptureParams : b),
            (this.MitekCaptureSession.CaptureParams.enableCV = !0))
          : ((MitekMobileWeb.MitekCaptureSession.CaptureParams =
              null == b ? MitekMobileWeb.MitekDefaultCaptureParams.BarcodeCaptureParams : b),
            (this.MitekCaptureSession.CaptureParams.enableCV = !1)),
        (MitekMobileWeb.MitekCaptureSession.CaptureParams.documentType = MitekMobileWeb.getImageTypeCode(
          a,
          !0,
        )),
        (MitekMobileWeb.MitekCaptureSession.MitekImageType = a),
        MitekMobileWeb.MitekCaptureSession
      );
    },
    getCaptureSession: function () {
      return MitekMobileWeb.MitekCaptureSession;
    },
    processURI: function (a) {
      (a.captureParams = a.params),
        (MitekMobileWeb.MitekMibiData.ImageSource.Method = 'processURI'),
        (a.imageData = a.dataURI),
        (MitekMobileWeb.MitekCaptureSession.Callback = a.callback),
        MitekMobileWeb.processDataURL(a);
    },
    processDataURL: function (a) {
      MitekMobileWeb.initCaptureSession(a.documentType, a.captureParams);
      (MitekMobileWeb.MitekMibiData.ImageSource.Upload = 'false'),
        (MitekMobileWeb.MitekCaptureSession.Callback = a.callback),
        (MitekMobileWeb.MitekMibiData.ImageSource.Method = 'processDataURL');
      var b = MitekMobileWeb.convertDataURItoBlob(a.imageData, 'image/jpeg');
      MitekMobileWeb.processImageFromCapture(b);
    },
    processImageData: function (a) {
      var b = MitekMobileWeb.initCaptureSession(a.documentType, a.captureParams);
      (MitekMobileWeb.MitekMibiData.ImageSource.Upload = 'false'),
        (MitekMobileWeb.MitekCaptureSession.Callback = a.callback),
        (MitekMobileWeb.MitekMibiData.ImageSource.Method = 'processImageData'),
        MitekMobileWeb.runIQA(a.imageData, b, a.callback);
    },
    processImageFile: function (a) {
      function b(b) {
        MitekMobileWeb.runIQA(b, c, a.callback);
      }
      var c = MitekMobileWeb.initCaptureSession(a.documentType, a.captureParams);
      (MitekMobileWeb.MitekCaptureSession.Callback = a.callback),
        (MitekMobileWeb.MitekMibiData.ImageSource.Method = 'processImageFile'),
        (MitekMobileWeb.MitekMibiData.ImageSource.Upload = 'true'),
        MitekMobileWeb.encodeRawImage(a.imageData, b);
    },
    MitekCaptureSession: {
      MitekImageType: '',
      Callback: '',
      CVStartCallback: null,
      ProcessImageCallback: null,
      CaptureParams: '',
      EXIFData: {},
    },
    MitekMibiAction: {
      PAGE_LOADED: 'PL',
      WORK_FLOW: 'WF',
      START_CAPTURE: 'SC',
      PICTURE_CAPTURED: 'PC',
      SKIP_LINK: 'SL',
      STATE_SELECTED: 'SP',
      BACK_PARTIAL_DATA_FAILURE: 'ID',
      DEVICE_EXCLUDED_ERROR: 'DE',
      TOTAL_CV_TIME: 'TC',
      TOTAL_ENCODING_TIME: 'EI',
      FULL_BACK_SENT: 'FB',
      CV_ENCODING_QUALITY: 'QX',
      CV_IMAGE_WIDTH: 'QW',
      CV_IMAGE_HEIGHT: 'QH',
      CV_LANDSCAPE_PORTRAIT: 'LP',
      CV_MEASURE_CONFIDENCE: 'QC',
      CV_MEASURE_MIN_WIDTH: 'QM',
      CV_ERROR_FOCUS: 'QF',
      CV_ERROR_TOO_DARK: 'QD',
      CV_ERROR_TOO_FAR: 'TF',
      CV_ERROR_SKEW: 'QS',
      CV_ERROR_HORIZONTAL_FILL: 'HF',
      CV_ERROR_MIN_PADDING: 'MP',
      CV_ERROR_CONFIDENCE: 'QE',
      CV_ERROR_FAILURE: 'QQ',
      CV_SUCCESS: 'SU',
      CV_FINAL_IMAGE_SIZE: 'IS',
      CV_NO_BARCODE_FOUND: 'NB',
      CV_ERROR_GLARE: 'GD',
      CV_ERROR_FOUR_CORNERS: 'FC',
      AUTOCAPTURE_START: 'SS',
      AUTOCAPTURE_STOP: 'C',
      AUTOCAPTURE_FRAME_PROCESSED: 'MC',
      NOT_FOUND: 'NF',
      BRIGHTNESS_FAILED: 'BF',
      SHAPRNESS_FAILED: 'SF',
      AUTOCAPTURE_TIME: 'MT',
      AUTOCAPTURE_TIMEOUT: 'MF',
      AUTOCAPTURE_ROTATE: 'RP',
      MEASURED_HEIGHT: 'MH',
      MEASURED_WIDTH: 'MW',
      MEASURED_VIDEO_FRAME: 'MV',
      CV_MEASURE_BRIGHTNESS: 'MB',
      CV_MEASURE_SHARPNESS: 'MS',
      CV_ERROR_LOW_CONTRAST: 'LC',
      CV_ERROR_ASPECT_RATIO: 'AR',
      CV_ERROR_BUSY_BACKGROUND: 'BB',
    },
    MitekCaptureResult: {
      IQA_GOOD: 0,
      IQA_NF: 1,
      IQA_OOF: 2,
      IQA_DARK: 3,
      IQA_MINFILL: 4,
      IQA_SKEW: 5,
      IQA_MINWIDTH: 6,
      IQA_GLARE: 7,
      IQA_FOURCORNERS: 8,
      IQA_CORRUPTIMAGE: 9,
      IQA_MINPADDING: 10,
      IQA_LOWCONTRAST: 11,
      IQA_BUSYBACKGROUND: 12,
      IQA_IMAGETOOSMALL: 13,
      PERMISSION_DENIED: 99,
      Result: function () {
        return {
          errors: [],
          status: '',
          Metrics: {},
          finalImage: null,
        };
      },
    },
    captureErrorCode: {
      GOOD: 0,
      NF: 1,
      OOF: 2,
      DARK: 3,
      MINFILL: 4,
      SKEW: 5,
      MINWIDTH: 6,
      GLARE: 7,
      FOURCORNERS: 8,
      IQA_CORRUPTIMAGE: 9,
      IQA_MINPADDING: 10,
      IQA_LOWCONTRAST: 11,
      IQA_BUSYBACKGROUND: 12,
      IQA_IMAGETOOSMALL: 13,
    },
    MitekImageTypeCode: {
      ID: 10,
      PASSPORT: 20,
      CHECK: 50,
      VIN: 60,
      DOCUMENT: 70,
      SELFIE: 85,
      BARCODE_PDF417: 100,
      OTHER: 1e3,
    },
    MitekDefaultCaptureParams: {
      StandardCaptureParams: {
        encoding: 'jpeg',
        jpegEncodingQuality: 70,
        skip4Corners: !0,
        isSharpnessOn: !0,
        isBrightnessOn: !0,
        validateSharpness: !0,
        validateBrightness: !0,
        validateConfidence: !1,
        validateMinFill: !0,
        thresholds: {
          SHARPNESS: 0.31,
          BRIGHTNESS: 0.19,
          MIN_FILL: 0,
          CONFIDENCE: 0,
        },
      },
      BarcodeCaptureParams: {
        encoding: 'jpeg',
        jpegEncodingQuality: 70,
        isSharpnessOn: !0,
        isBrightnessOn: !0,
        isMinWidthOn: !0,
        skipPDF417: !1,
        validateSharpness: !0,
        validateBrightness: !0,
        validateMinWidth: !0,
        validateConfidence: !0,
        thresholds: {
          SHARPNESS: 0.31,
          BRIGHTNESS: 0.19,
          WIDTH_FACTOR_PORTRAIT: 0.39,
          WIDTH_FACTOR_LANDSCAPE: 0.39,
          CONFIDENCE: 0.78,
        },
      },
    },
    CVDefaultThresholds: {
      GLOBAL: {
        minimumImageSize: 450,
        maximumDefaultImageSize: 1920,
        maximumDefaultDocumentImageSize: 4096,
        nonMobileFocusThreshold: 150,
      },
      ID: {
        detectFourCorners: !0,
        detectGlare: !0,
        detectFocus: !0,
        detectExposure: !0,
        glareRoiPercentage: 90,
        glarePixelMinIntensity: 245,
        glarePercentage: 11,
        glareMinWidthPercentage: 20,
        fourCornerThreshold: 600,
        glareThreshold: 500,
        focusThreshold: isMobileDevice() ? 300 : 150,
        exposureThreshold: 320,
        horizontalFillThreshold: 400,
        minPaddingThreshold: 7,
        skewAngleThreshold: 100,
        lowContrastThreshold: 600,
        busyBackgroundThreshold: 650,
        aspectRatio: 1.53,
        aspectRatioThreshold: 0.2,
      },
      Document: {
        detectFourCorners: !0,
        detectGlare: !1,
        detectFocus: !0,
        detectExposure: !0,
        glareRoiPercentage: 90,
        glarePixelMinIntensity: 245,
        glarePercentage: 11,
        glareMinWidthPercentage: 20,
        fourCornerThreshold: 600,
        glareThreshold: 760,
        focusThreshold: isMobileDevice() ? 400 : 150,
        exposureThreshold: 320,
        horizontalFillThreshold: 650,
        minPaddingThreshold: 7,
        skewAngleThreshold: 100,
        lowContrastThreshold: 600,
        busyBackgroundThreshold: 650,
      },
      VIN: {
        detectFourCorners: !1,
        detectGlare: !1,
        detectFocus: !0,
        detectExposure: !0,
        glareRoiPercentage: 90,
        glarePixelMinIntensity: 245,
        glarePercentage: 11,
        glareMinWidthPercentage: 20,
        fourCornerThreshold: 800,
        glareThreshold: 448,
        focusThreshold: isMobileDevice() ? 400 : 150,
        exposureThreshold: 320,
        horizontalFillThreshold: 650,
        minPaddingThreshold: 7,
        skewAngleThreshold: 25,
        lowContrastThreshold: 600,
        busyBackgroundThreshold: 750,
      },
      Passport: {
        detectFourCorners: !0,
        detectGlare: !0,
        detectFocus: !0,
        detectExposure: !0,
        glareRoiPercentage: 90,
        glarePixelMinIntensity: 245,
        glarePercentage: 11,
        glareMinWidthPercentage: 20,
        fourCornerThreshold: 600,
        glareThreshold: 500,
        focusThreshold: isMobileDevice() ? 300 : 50,
        exposureThreshold: 320,
        horizontalFillThreshold: 500,
        minPaddingThreshold: 7,
        skewAngleThreshold: 200,
        lowContrastThreshold: 650,
        busyBackgroundThreshold: 800,
      },
      Check: {
        detectFourCorners: !0,
        detectGlare: !1,
        detectFocus: !0,
        detectExposure: !0,
        glareRoiPercentage: 90,
        glarePixelMinIntensity: 245,
        glarePercentage: 11,
        glareMinWidthPercentage: 20,
        fourCornerThreshold: 600,
        glareThreshold: 760,
        focusThreshold: isMobileDevice() ? 400 : 150,
        exposureThreshold: 320,
        horizontalFillThreshold: 650,
        minPaddingThreshold: 4,
        skewAngleThreshold: 100,
        lowContrastThreshold: 600,
        busyBackgroundThreshold: 750,
      },
      Selfie: {
        detectFourCorners: !1,
        detectGlare: !1,
        detectFocus: !1,
        detectExposure: !1,
        glareRoiPercentage: 0,
        glarePixelMinIntensity: 0,
        glarePercentage: 0,
        glareMinWidthPercentage: 0,
        fourCornerThreshold: 0,
        glareThreshold: 0,
        focusThreshold: 0,
        exposureThreshold: 0,
        horizontalFillThreshold: 0,
        minPaddingThreshold: 0,
        skewAngleThreshold: 0,
        lowContrastThreshold: 0,
        busyBackgroundThreshold: 0,
      },
      Other: {
        detectFourCorners: !1,
        detectGlare: !1,
        detectFocus: !0,
        detectExposure: !0,
        glareRoiPercentage: 90,
        glarePixelMinIntensity: 245,
        glarePercentage: 11,
        glareMinWidthPercentage: 20,
        fourCornerThreshold: 600,
        glareThreshold: 760,
        focusThreshold: isMobileDevice() ? 400 : 150,
        exposureThreshold: 320,
        horizontalFillThreshold: 650,
        minPaddingThreshold: 7,
        skewAngleThreshold: 100,
        lowContrastThreshold: 600,
        busyBackgroundThreshold: 750,
      },
    },
    nonWebWorkerParams: { thresholds: {}, callback: null },
    scanner: null,
    autoCaptureParams: {
      deviceSelectorId: null,
      deviceId: null,
      callback: null,
      timeout: 2e4,
      numOfWorkers: 3,
      frequency: 10,
      sharpenStrength: 0.05,
      videoSrc: null,
      recordSession: null,
      fullScreen: !1,
    },
    AutoCaptureResult: { SUCCESS: 'success', FAILURE: 'failure' },
    AutoCaptureError: {
      CANCELLED: 'cancelled',
      TIMEOUT: 'timeout',
      ALREADY_RUNNING: 'already-running',
    },
    mibiStartTime: new Date().getTime(),
    getUserAgent: function () {
      return navigator.userAgent;
    },
    isAndroid: function () {
      return null != this.getUserAgent().match(/Android/i);
    },
    isSafari: function () {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    isChrome: function () {
      var a = !!window.chrome;
      if (a) return a;
      var b = /crios/i;
      return b.test(window.navigator.userAgent);
    },
    getDeviceModel: function () {
      var a = this.getUserAgent(),
        b = a.indexOf('Build');
      a = a.substring(0, b);
      var c = a.lastIndexOf(';'),
        d = a.substring(c + 1, a.length);
      return d.trim();
    },
    captureImage: function (a) {
      console.log('Mobile Web 2.6.1: initialize'),
        (this.MitekCaptureSession.ProcessImageCallback = a);
      var b =
          this.MitekCaptureSession.CaptureParams.allowFileBrowser &&
          1 == this.MitekCaptureSession.CaptureParams.allowFileBrowser
            ? !0
            : !1,
        c =
          MitekMobileWeb.getImageTypeCode(MitekMobileWeb.MitekCaptureSession.MitekImageType) ==
          MitekMobileWeb.MitekImageTypeCode.SELFIE;
      if (this.isSafari()) {
        var d = '<input type="file" ';
        this.isSafari() && c === !0
          ? (d += 'capture="user" ')
          : b === !1 && (d += 'capture="camera" '),
          (d +=
            'accept="image/*" id="mitekCameraControl" style="display:none" onchange="window.parent.MitekMobileWeb.processCapturedImage(this)">');
        var e = document.getElementById('mitekCameraFrame');
        e && e.parentNode.removeChild(e),
          (e = document.createElement('iframe')),
          e.setAttribute('id', 'mitekCameraFrame'),
          e.setAttribute('style', 'display:none'),
          (e.src = 'about:blank'),
          document.body.appendChild(e),
          e.contentWindow.document.open('text/html', 'replace'),
          e.contentWindow.document.write(d),
          e.contentWindow.document.close(),
          e.contentWindow.document.getElementById('mitekCameraControl').click();
      } else {
        var f = document.getElementById('mitekCameraInput');
        f && f.parentNode.removeChild(mitekCameraInput),
          (f = document.createElement('input')),
          f.setAttribute('type', 'file'),
          f.setAttribute('id', 'mitekCameraControl'),
          f.setAttribute('style', 'display:none'),
          f.setAttribute('accept', 'image/*'),
          this.isSafari() && c === !0
            ? f.setAttribute('capture', 'user')
            : b === !1 && f.setAttribute('capture', 'camera'),
          f.setAttribute('onchange', 'MitekMobileWeb.processCapturedImage(this)'),
          document.body.appendChild(f),
          f.click();
      }
    },
    mat2ImageData: function (a, b) {
      null == a.cols && (a.cols = a.width), null == a.rows && (a.rows = a.height);
      var c = {
          width: a.cols,
          height: a.rows,
          data: new Uint8Array(new ArrayBuffer(a.cols * a.rows * 4)),
        },
        d = new Uint32Array(c.data.buffer),
        e = 255 << 24,
        f = a.cols * a.rows,
        g = 0;
      if (b) for (; --f >= 0; ) (g = a.data[f]), (d[f] = e | ~((g << 16) | (g << 8) | g));
      else for (; --f >= 0; ) (g = a.data[f]), (d[f] = e | ((g << 16) | (g << 8) | g));
      return c;
    },
    getDefaultThresholds: function (a) {
      var b = this.CVDefaultThresholds.Other,
        c = a.documentType;
      b =
        c == MitekMobileWeb.MitekImageTypeCode.ID
          ? MitekMobileWeb.CVDefaultThresholds.ID
          : c == MitekMobileWeb.MitekImageTypeCode.PASSPORT
          ? MitekMobileWeb.CVDefaultThresholds.Passport
          : c == MitekMobileWeb.MitekImageTypeCode.CHECK
          ? MitekMobileWeb.CVDefaultThresholds.Check
          : c == MitekMobileWeb.MitekImageTypeCode.VIN
          ? MitekMobileWeb.CVDefaultThresholds.VIN
          : c == MitekMobileWeb.MitekImageTypeCode.DOCUMENT
          ? MitekMobileWeb.CVDefaultThresholds.Document
          : c == MitekMobileWeb.MitekImageTypeCode.SELFIE
          ? MitekMobileWeb.CVDefaultThresholds.Selfie
          : MitekMobileWeb.CVDefaultThresholds.Other;
      var d = {
        detectFourCorners:
          void 0 !== a.cvParams.detectFourCorners
            ? a.cvParams.detectFourCorners
            : b.detectFourCorners,
        detectGlare: void 0 !== a.cvParams.detectGlare ? a.cvParams.detectGlare : b.detectGlare,
        detectFocus: void 0 !== a.cvParams.detectFocus ? a.cvParams.detectFocus : b.detectFocus,
        detectExposure:
          void 0 !== a.cvParams.detectExposure ? a.cvParams.detectExposure : b.detectExposure,
        glareRoiPercentage:
          void 0 !== a.cvParams.glareRoiPercentage
            ? a.cvParams.glareRoiPercentage
            : b.glareRoiPercentage,
        glarePixelMinIntensity:
          void 0 !== a.cvParams.glarePixelMinIntensity
            ? a.cvParams.glarePixelMinIntensity
            : b.glarePixelMinIntensity,
        glarePercentage:
          void 0 !== a.cvParams.glarePercentage ? a.cvParams.glarePercentage : b.glarePercentage,
        glareMinWidthPercentage:
          void 0 !== a.cvParams.glareMinWidthPercentage
            ? a.cvParams.glareMinWidthPercentage
            : b.glareMinWidthPercentage,
        fourCornerThreshold:
          void 0 !== a.cvParams.fourCornerThreshold
            ? a.cvParams.fourCornerThreshold
            : b.fourCornerThreshold,
        glareThreshold:
          void 0 !== a.cvParams.glareThreshold ? a.cvParams.glareThreshold : b.glareThreshold,
        focusThreshold:
          void 0 !== a.cvParams.focusThreshold ? a.cvParams.focusThreshold : b.focusThreshold,
        exposureThreshold:
          void 0 !== a.cvParams.exposureThreshold
            ? a.cvParams.exposureThreshold
            : b.exposureThreshold,
        minPaddingThreshold:
          void 0 !== a.cvParams.minPaddingThreshold
            ? a.cvParams.minPaddingThreshold
            : b.minPaddingThreshold,
        horizontalFillThreshold:
          void 0 !== a.cvParams.horizontalFillThreshold
            ? a.cvParams.horizontalFillThreshold
            : b.horizontalFillThreshold,
        skewAngleThreshold:
          void 0 !== a.cvParams.skewAngleThreshold
            ? a.cvParams.skewAngleThreshold
            : b.skewAngleThreshold,
        lowContrastThreshold:
          void 0 !== a.cvParams.lowContrastThreshold
            ? a.cvParams.lowContrastThreshold
            : b.lowContrastThreshold,
        busyBackgroundThreshold:
          void 0 !== a.cvParams.busyBackgroundThreshold
            ? a.cvParams.busyBackgroundThreshold
            : b.busyBackgroundThreshold,
      };
      return (
        (d.documentType = a.documentType),
        (d.documentType == MitekMobileWeb.MitekImageTypeCode.VIN ||
          d.documentType == MitekMobileWeb.MitekImageTypeCode.DOCUMENT ||
          d.documentType == MitekMobileWeb.MitekImageTypeCode.PASSPORT ||
          d.documentType == MitekMobileWeb.MitekImageTypeCode.CHECK ||
          d.documentType == MitekMobileWeb.MitekImageTypeCode.SELFIE) &&
          (d.documentType = MitekMobileWeb.MitekImageTypeCode.OTHER),
        d
      );
    },
    getWorker: function () {
      var a = null;
      if ('undefined' == typeof Worker)
        return console.warn('Web workers not supported by this browser'), null;
      var b = '';
      return (
        'undefined' != typeof mitekWorkerPath && '' !== mitekWorkerPath && (b = mitekWorkerPath),
        'undefined' != typeof MitekConfig &&
          'undefined' != typeof MitekConfig.mitekWorkerPath &&
          '' !== MitekConfig.mitekWorkerPath &&
          (b = MitekConfig.mitekWorkerPath),
        '' == b
          ? null
          : ((a = new Worker(b)),
            (a.onerror = function () {
              console.warn('Unable to load worker from path: ' + b),
                (MitekMobileWeb.mitekWorker = null);
            }),
            a)
      );
    },
    runCVFNonWebWorker: function (a, b, c, d, e) {
      if (
        (console.log('Running Non-Worker Mitek CV - enter'),
        null != a.data.buffer && a.data.buffer.byteLength)
      )
        MitekMobileWeb.runCVFNonWebWorkerProcess(a, b, c);
      else {
        var f = document.getElementById('mitekCameraFrame'),
          g = f.contentWindow.document.getElementById('mitekCameraControl').files[0];
        (MitekMobileWeb.nonWebWorkerParams.thresholds = b),
          (MitekMobileWeb.nonWebWorkerParams.callback = c),
          MitekMobileWeb.encodeRawImage(g, MitekMobileWeb.processNonWebWorkerImage);
      }
    },
    processNonWebWorkerImage: function (a) {
      MitekMobileWeb.runCVFNonWebWorkerProcess(
        a,
        MitekMobileWeb.nonWebWorkerParams.thresholds,
        MitekMobileWeb.nonWebWorkerParams.callback,
      );
    },
    runCVFNonWebWorkerProcess: function (a, b, c) {
      var d = new Date().getTime(),
        e = new Date().getTime(),
        f = {};
      (f.iqa = []), (f.errors = []), (f.status = 'success'), (f.errors = []);
      var e = new Date().getTime(),
        g = new MtkMWebApi(),
        h = {};
      (b.imageData = a), g.PerformIQA(b, h);
      var i = new Date().getTime() - d;
      console.log('CV Total Time: ' + i + ' ms'),
        (f.Metrics = {
          confidence: void 0,
          isPortrait: void 0,
          minFill: void 0,
          sharpness: void 0,
          brightness: void 0,
          fourCornerScore: h.fourCornerScore,
          glareScore: h.glareScore,
          focusScore: h.focusScore,
          exposureScore: h.exposureScore,
          horizontalFillScore: h.horizontalFill,
          minPaddingScore: h.minPadding,
          skewAngleScore: h.skewAngle,
          fourCornerDuration: h.fourCornerDuration,
          glareDuration: h.glareDuration,
          focusDuration: h.focusDuration,
          exposureDuration: h.exposureDuration,
          glareTop: h.glareTop,
          glareBottom: h.glareBottom,
          glareLeft: h.glareLeft,
          glareRight: h.glareRight,
          fourCornerA: { x: h.ax, y: h.ay },
          fourCornerB: { x: h.bx, y: h.by },
          fourCornerC: { x: h.cx, y: h.cy },
          fourCornerD: { x: h.dx, y: h.dy },
          lowContrastScore: h.lowContrastConfidence,
          busyBackgroundScore: h.busyBackground,
          totalCVTime: i,
        });
      var j = 'success',
        k = !1,
        l =
          MitekMobileWeb.getImageTypeCode(MitekMobileWeb.MitekCaptureSession.MitekImageType) ==
          MitekMobileWeb.MitekImageTypeCode.ID;
      if (
        (1 == b.detectFourCorners &&
          f.Metrics.fourCornerScore < b.fourCornerThreshold &&
          ((k = !0),
          (j = 'failure'),
          console.warn(
            'Four Corners failed: (' +
              f.Metrics.fourCornerScore +
              ' < ' +
              b.fourCornerThreshold +
              ')',
          ),
          f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_FOURCORNERS),
          MitekMobileWeb.logEvent(
            MitekMobileWeb.MitekMibiAction.CV_ERROR_FOUR_CORNERS,
            MitekMobileWeb.convertNumberToString(f.Metrics.fourCornerScore),
          )),
        1 == b.detectFourCorners)
      ) {
        if (
          (f.Metrics.horizontalFillScore < b.horizontalFillThreshold &&
            ((j = 'failure'),
            console.warn(
              'Horizontal Fill failed: (' +
                f.Metrics.horizontalFillScore +
                ' < ' +
                b.horizontalFillThreshold +
                ')',
            ),
            f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINFILL),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_HORIZONTAL_FILL,
              MitekMobileWeb.convertNumberToString(f.Metrics.horizontalFillScore),
            )),
          f.Metrics.minPaddingScore < b.minPaddingThreshold &&
            ((j = 'failure'),
            console.warn(
              'Minimum Padding failed: (' +
                f.Metrics.minPaddingScore +
                ' < ' +
                b.minPaddingThreshold +
                ')',
            ),
            f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINPADDING),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_MIN_PADDING,
              MitekMobileWeb.convertNumberToString(f.Metrics.minPaddingScore),
            )),
          f.Metrics.skewAngleScore > b.skewAngleThreshold &&
            ((j = 'failure'),
            console.warn(
              'Skew Angle failed: (' +
                f.Metrics.skewAngleScore +
                ' > ' +
                b.skewAngleThreshold +
                ')',
            ),
            f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_SKEW),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_SKEW,
              MitekMobileWeb.convertNumberToString(f.Metrics.skewAngleScore),
            )),
          k && f.Metrics.lowContrastScore < b.lowContrastThreshold)
        )
          (j = 'failure'),
            console.warn(
              'Low Contrast failed: (' +
                f.Metrics.lowContrastScore +
                ' < ' +
                b.lowContrastThreshold +
                ')',
            ),
            f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_LOWCONTRAST),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_LOW_CONTRAST,
              MitekMobileWeb.convertNumberToString(f.Metrics.lowContrastScore),
            );
        else if (!k && l) {
          var m = MitekMobileWeb.determineAspectRatios(h),
            n = MitekMobileWeb.testAspectRatio(
              m,
              MitekMobileWeb.CVDefaultThresholds.ID.aspectRatio,
              MitekMobileWeb.CVDefaultThresholds.ID.aspectRatioThreshold,
            );
          n.passed ||
            ((j = 'failure'),
            console.warn(n.error),
            f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_LOWCONTRAST),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_ASPECT_RATIO,
              MitekMobileWeb.convertBooleanToString(n.passed),
            ));
        }
        k &&
          f.Metrics.busyBackgroundScore < b.busyBackgroundThreshold &&
          ((j = 'failure'),
          console.warn(
            'Busy Background failed: (' +
              f.Metrics.busyBackgroundScore +
              ' < ' +
              b.busyBackgroundThreshold +
              ')',
          ),
          f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_BUSYBACKGROUND),
          MitekMobileWeb.logEvent(
            MitekMobileWeb.MitekMibiAction.CV_ERROR_BUSY_BACKGROUND,
            MitekMobileWeb.convertNumberToString(f.Metrics.busyBackgroundScore),
          ));
      }
      1 == b.detectGlare &&
        f.Metrics.glareScore < b.glareThreshold &&
        ((j = 'failure'),
        console.warn('Glare failed: (' + f.Metrics.glareScore + ' < ' + b.glareThreshold + ')'),
        f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_GLARE),
        MitekMobileWeb.logEvent(
          MitekMobileWeb.MitekMibiAction.CV_ERROR_GLARE,
          MitekMobileWeb.convertNumberToString(f.Metrics.glareScore),
        )),
        1 == b.detectFocus &&
          f.Metrics.focusScore < b.focusThreshold &&
          ((j = 'failure'),
          console.warn('Focus failed: (' + f.Metrics.focusScore + ' < ' + b.focusThreshold + ')'),
          f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_OOF),
          MitekMobileWeb.logEvent(
            MitekMobileWeb.MitekMibiAction.CV_ERROR_FOCUS,
            MitekMobileWeb.convertNumberToString(f.Metrics.focusScore),
          )),
        1 == b.detectExposure &&
          f.Metrics.exposureScore < b.exposureThreshold &&
          ((j = 'failure'),
          console.warn(
            'Exposure failed: (' + f.Metrics.exposureScore + ' < ' + b.exposureThreshold + ')',
          ),
          f.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_DARK),
          MitekMobileWeb.logEvent(
            this.MitekMibiAction.CV_ERROR_TOO_DARK,
            MitekMobileWeb.convertNumberToString(f.Metrics.exposureScore),
          )),
        (f.status = j),
        MitekMobileWeb.processCVResult(f, null, b, a, c, e);
    },
    runIQA: function (a, b, c) {
      MitekMobileWeb.runCV(a, b.CaptureParams, c);
    },
    runCV: function (a, b, c) {
      var d = new Date().getTime(),
        e = {};
      (e.iqa = []), (e.errors = []), (e.status = 'success');
      var f, g, h;
      if (b.documentType != MitekMobileWeb.MitekImageTypeCode.BARCODE_PDF417)
        if (void 0 === typeof b.enableCV || b.enableCV === !0) {
          void 0 === b.cvParams && (b.cvParams = {});
          var i = this.getDefaultThresholds(b);
          console.log('Run CV with document type: ' + i.documentType);
          var j = {};
          e.errors = [];
          var k = new Date().getTime();
          (i.documentType === MitekMobileWeb.MitekImageTypeCode.PASSPORT ||
            i.documentType === MitekMobileWeb.MitekImageTypeCode.SELFIE) &&
            (i.documentType = MitekMobileWeb.MitekImageTypeCode.OTHER),
            null != MitekMobileWeb.mitekWorker
              ? (console.log('Running Webworker Mitek CV - enter'),
                (MitekMobileWeb.mitekWorker.onmessage = function (a) {
                  j = a.data;
                  var f = new Date().getTime() - k;
                  console.log('CV Total Time: ' + f + ' ms'),
                    (e.Metrics = {
                      confidence: void 0,
                      isPortrait: void 0,
                      minFill: void 0,
                      sharpness: void 0,
                      brightness: void 0,
                      fourCornerScore: j.fourCornerScore,
                      glareScore: j.glareScore,
                      focusScore: j.focusScore,
                      exposureScore: j.exposureScore,
                      horizontalFillScore: j.horizontalFill,
                      minPaddingScore: j.minPadding,
                      skewAngleScore: j.skewAngle,
                      fourCornerDuration: j.fourCornerDuration,
                      glareDuration: j.glareDuration,
                      focusDuration: j.focusDuration,
                      exposureDuration: j.exposureDuration,
                      glareTop: j.glareTop,
                      glareBottom: j.glareBottom,
                      glareLeft: j.glareLeft,
                      glareRight: j.glareRight,
                      fourCornerA: { x: j.ax, y: j.ay },
                      fourCornerB: { x: j.bx, y: j.by },
                      fourCornerC: { x: j.cx, y: j.cy },
                      fourCornerD: { x: j.dx, y: j.dy },
                      lowContrastScore: j.lowContrastConfidence,
                      busyBackgroundScore: j.busyBackground,
                      totalCVTime: f,
                    });
                  var g = 'success',
                    l = !1,
                    m =
                      MitekMobileWeb.getImageTypeCode(
                        MitekMobileWeb.MitekCaptureSession.MitekImageType,
                      ) == MitekMobileWeb.MitekImageTypeCode.ID;
                  if (
                    (1 == i.detectFourCorners &&
                      e.Metrics.fourCornerScore < i.fourCornerThreshold &&
                      ((l = !0),
                      (g = 'failure'),
                      console.warn(
                        'Four Corners failed: (' +
                          e.Metrics.fourCornerScore +
                          ' < ' +
                          i.fourCornerThreshold +
                          ')',
                      ),
                      e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_FOURCORNERS),
                      MitekMobileWeb.logEvent(
                        MitekMobileWeb.MitekMibiAction.CV_ERROR_FOUR_CORNERS,
                        MitekMobileWeb.convertNumberToString(e.Metrics.fourCornerScore),
                      )),
                    1 == i.detectFourCorners)
                  ) {
                    if (
                      (e.Metrics.horizontalFillScore < i.horizontalFillThreshold &&
                        ((g = 'failure'),
                        console.warn(
                          'Horizontal Fill failed: (' +
                            e.Metrics.horizontalFillScore +
                            ' < ' +
                            i.horizontalFillThreshold +
                            ')',
                        ),
                        e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINFILL),
                        MitekMobileWeb.logEvent(
                          MitekMobileWeb.MitekMibiAction.CV_ERROR_HORIZONTAL_FILL,
                          MitekMobileWeb.convertNumberToString(e.Metrics.horizontalFillScore),
                        )),
                      e.Metrics.minPaddingScore < i.minPaddingThreshold &&
                        ((g = 'failure'),
                        console.warn(
                          'Minimum Padding failed: (' +
                            e.Metrics.minPaddingScore +
                            ' < ' +
                            i.minPaddingThreshold +
                            ')',
                        ),
                        e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINPADDING),
                        MitekMobileWeb.logEvent(
                          MitekMobileWeb.MitekMibiAction.CV_ERROR_MIN_PADDING,
                          MitekMobileWeb.convertNumberToString(e.Metrics.minPaddingScore),
                        )),
                      e.Metrics.skewAngleScore > i.skewAngleThreshold &&
                        ((g = 'failure'),
                        console.warn(
                          'Skew Angle failed: (' +
                            e.Metrics.skewAngleScore +
                            ' > ' +
                            i.skewAngleThreshold +
                            ')',
                        ),
                        e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_SKEW),
                        MitekMobileWeb.logEvent(
                          MitekMobileWeb.MitekMibiAction.CV_ERROR_SKEW,
                          MitekMobileWeb.convertNumberToString(e.Metrics.skewAngleScore),
                        )),
                      l && e.Metrics.lowContrastScore < i.lowContrastThreshold)
                    )
                      (g = 'failure'),
                        console.warn(
                          'Low Contrast failed: (' +
                            e.Metrics.lowContrastScore +
                            ' < ' +
                            i.lowContrastThreshold +
                            ')',
                        ),
                        e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_LOWCONTRAST),
                        MitekMobileWeb.logEvent(
                          MitekMobileWeb.MitekMibiAction.CV_ERROR_LOW_CONTRAST,
                          MitekMobileWeb.convertNumberToString(e.Metrics.lowContrastScore),
                        );
                    else if (!l && m) {
                      var n = MitekMobileWeb.determineAspectRatios(j),
                        o = MitekMobileWeb.testAspectRatio(
                          n,
                          MitekMobileWeb.CVDefaultThresholds.ID.aspectRatio,
                          MitekMobileWeb.CVDefaultThresholds.ID.aspectRatioThreshold,
                        );
                      o.passed ||
                        ((g = 'failure'),
                        console.warn(o.error),
                        e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_LOWCONTRAST),
                        MitekMobileWeb.logEvent(
                          MitekMobileWeb.MitekMibiAction.CV_ERROR_ASPECT_RATIO,
                          MitekMobileWeb.convertBooleanToString(o.passed),
                        ));
                    }
                    l &&
                      e.Metrics.busyBackgroundScore < i.busyBackgroundThreshold &&
                      ((g = 'failure'),
                      console.warn(
                        'Busy Background failed: (' +
                          e.Metrics.busyBackgroundScore +
                          ' < ' +
                          i.busyBackgroundThreshold +
                          ')',
                      ),
                      e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_BUSYBACKGROUND),
                      MitekMobileWeb.logEvent(
                        MitekMobileWeb.MitekMibiAction.CV_ERROR_BUSY_BACKGROUND,
                        MitekMobileWeb.convertNumberToString(e.Metrics.busyBackgroundScore),
                      ));
                  }
                  1 == i.detectGlare &&
                    e.Metrics.glareScore < i.glareThreshold &&
                    ((g = 'failure'),
                    console.warn(
                      'Glare failed: (' + e.Metrics.glareScore + ' < ' + i.glareThreshold + ')',
                    ),
                    e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_GLARE),
                    MitekMobileWeb.logEvent(
                      MitekMobileWeb.MitekMibiAction.CV_ERROR_GLARE,
                      MitekMobileWeb.convertNumberToString(e.Metrics.glareScore),
                    )),
                    1 == i.detectFocus &&
                      e.Metrics.focusScore < i.focusThreshold &&
                      ((g = 'failure'),
                      console.warn(
                        'Focus failed: (' + e.Metrics.focusScore + ' < ' + i.focusThreshold + ')',
                      ),
                      e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_OOF),
                      MitekMobileWeb.logEvent(
                        MitekMobileWeb.MitekMibiAction.CV_ERROR_FOCUS,
                        MitekMobileWeb.convertNumberToString(e.Metrics.focusScore),
                      )),
                    1 == i.detectExposure &&
                      e.Metrics.exposureScore < i.exposureThreshold &&
                      ((g = 'failure'),
                      console.warn(
                        'Exposure failed: (' +
                          e.Metrics.exposureScore +
                          ' < ' +
                          i.exposureThreshold +
                          ')',
                      ),
                      e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_DARK),
                      MitekMobileWeb.logEvent(
                        MitekMobileWeb.MitekMibiAction.CV_ERROR_TOO_DARK,
                        MitekMobileWeb.convertNumberToString(e.Metrics.exposureScore),
                      )),
                    (e.status = g),
                    MitekMobileWeb.processCVResult(e, h, b, j.imageData, c, d);
                }),
                (i.imageData = a),
                MitekMobileWeb.mitekWorker.postMessage(i, [a.data.buffer]),
                (MitekMobileWeb.mitekWorker.onerror = function (b) {
                  console.log('mitekworker error: ', b), MitekMobileWeb.runCVFNonWebWorker(a, i, c);
                }))
              : MitekMobileWeb.runCVFNonWebWorker(a, i, c);
        } else {
          if (
            ((h = mcv.analyzer.analyze4Corners(
              { width: a.width, height: a.height, data: a.data },
              b,
            )),
            MitekMobileWeb.logEvent(
              this.MitekMibiAction.CV_IMAGE_WIDTH,
              MitekMobileWeb.convertNumberToString(a.width),
            ),
            MitekMobileWeb.logEvent(
              this.MitekMibiAction.CV_IMAGE_HEIGHT,
              MitekMobileWeb.convertNumberToString(a.height),
            ),
            (e.image = h.gray),
            (e.Metrics = {
              confidence: void 0,
              isPortrait: void 0,
              minFill: void 0,
              sharpness: void 0,
              brightness: void 0,
            }),
            h.iqa &&
              ((e.Metrics.sharpness = h.iqa.sharpness),
              (e.Metrics.brightness = h.iqa.brightness),
              (f = h.iqa.sharpness),
              MitekMobileWeb.logEvent(
                this.MitekMibiAction.CV_MEASURE_SHARPNESS,
                MitekMobileWeb.convertNumberToString(f),
              ),
              console.debug('Sharpness=' + f),
              b.validateSharpness &&
                void 0 !== f &&
                f < b.thresholds.SHARPNESS &&
                (console.warn('Sharpness failed: (' + f + ' < ' + b.thresholds.SHARPNESS + ')'),
                e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_OOF),
                MitekMobileWeb.logEvent(
                  this.MitekMibiAction.CV_ERROR_FOCUS,
                  MitekMobileWeb.convertNumberToString(f),
                )),
              (g = h.iqa.brightness),
              MitekMobileWeb.logEvent(
                this.MitekMibiAction.CV_MEASURE_BRIGHTNESS,
                MitekMobileWeb.convertNumberToString(g),
              ),
              console.debug('Brightness=' + g),
              b.validateBrightness &&
                void 0 !== g &&
                g < b.thresholds.BRIGHTNESS &&
                (console.warn('Brightness failed: (' + g + ' < ' + b.thresholds.BRIGHTNESS + ')'),
                e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_DARK),
                MitekMobileWeb.logEvent(
                  this.MitekMibiAction.CV_ERROR_TOO_DARK,
                  MitekMobileWeb.convertNumberToString(g),
                ))),
            h.corners)
          ) {
            (e.Metrics.confidence = h.corners.confidence), (e.Metrics.minFill = h.corners.minFill);
            var l = h.corners;
            console.debug('Min Fill=' + l.minFill),
              b.validateMinFill &&
                l.minFill < b.thresholds.MIN_FILL &&
                (console.warn(
                  'Minfill failed: (' + l.minFill + ' < ' + b.thresholds.MIN_FILL + ')',
                ),
                e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINFILL),
                MitekMobileWeb.logEvent(
                  MitekMobileWeb.MitekMibiAction.CV_ERROR_TOO_FAR,
                  MitekMobileWeb.convertNumberToString(l.minFill),
                )),
              b.validateConfidence &&
                (l.confidence <= 0
                  ? (console.warn('Confidence failed: (' + l.confidence + ' < 0)'),
                    (e.errors = [MitekMobileWeb.MitekCaptureResult.IQA_NF]),
                    MitekMobileWeb.logEvent(
                      MitekMobileWeb.MitekMibiAction.CV_ERROR_SKEW,
                      MitekMobileWeb.convertNumberToString(l.confidence),
                    ))
                  : l.confidence > 0 &&
                    l.confidence < b.thresholds.CONFIDENCE &&
                    (console.warn(
                      'Skew failed: (' +
                        l.confidence +
                        ' > 0 and ' +
                        l.confidence +
                        ' < ' +
                        b.thresholds.CONFIDENCE +
                        ')',
                    ),
                    e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_SKEW),
                    MitekMobileWeb.logEvent(
                      MitekMobileWeb.MitekMibiAction.CV_ERROR_CONFIDENCE,
                      MitekMobileWeb.convertNumberToString(l.confidence),
                    )));
          }
          ((null == h.iqa && (b.isBrightnessOn || b.isSharpnessOn)) ||
            (null == h.corners && b.skip4Corners !== !0) ||
            e.errors.length > 0) &&
            (MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_FAILURE,
              this.MitekCaptureSession.MitekImageType,
            ),
            (e.status = 'failure')),
            MitekMobileWeb.processCVResult(e, h, b, a, c, d);
        }
      else if (
        (b.skipPDF417
          ? console.log('runCV - license back')
          : console.log('runCV - detect PDF417 barcode'),
        MitekMobileWeb.logEvent(
          MitekMobileWeb.MitekMibiAction.CV_IMAGE_WIDTH,
          MitekMobileWeb.convertNumberToString(a.width),
        ),
        MitekMobileWeb.logEvent(
          MitekMobileWeb.MitekMibiAction.CV_IMAGE_HEIGHT,
          MitekMobileWeb.convertNumberToString(a.height),
        ),
        (h = mcv.analyzer.analyzePDF417({ width: a.width, height: a.height, data: a.data }, b)),
        (e.image = h.gray),
        (e.Metrics = {
          confidence: void 0,
          isPortrait: void 0,
          minWidth: void 0,
          sharpness: void 0,
          brightness: void 0,
        }),
        h.iqa &&
          ((e.Metrics.sharpness = h.iqa.sharpness),
          (e.Metrics.brightness = h.iqa.brightness),
          (f = h.iqa.sharpness),
          MitekMobileWeb.logEvent(
            MitekMobileWeb.MitekMibiAction.CV_MEASURE_BRIGHTNESS,
            MitekMobileWeb.convertNumberToString(f),
          ),
          console.debug('Sharpness=' + f),
          b.validateSharpness &&
            void 0 !== f &&
            f < b.thresholds.SHARPNESS &&
            (console.warn('Sharpness failed: (' + f + ' < ' + b.thresholds.SHARPNESS + ')'),
            e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_OOF),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_FOCUS,
              MitekMobileWeb.convertNumberToString(f),
            )),
          (g = h.iqa.brightness),
          MitekMobileWeb.logEvent(
            this.MitekMibiAction.CV_MEASURE_SHARPNESS,
            MitekMobileWeb.convertNumberToString(g),
          ),
          console.debug('Brightness=' + g),
          b.validateBrightness &&
            void 0 !== g &&
            g < b.thresholds.BRIGHTNESS &&
            (console.warn('Brightness failed: (' + g + ' < ' + b.thresholds.BRIGHTNESS + ')'),
            e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_DARK),
            MitekMobileWeb.logEvent(
              MitekMobileWeb.MitekMibiAction.CV_ERROR_TOO_DARK,
              MitekMobileWeb.convertNumberToString(g),
            ))),
        h.pdf417)
      ) {
        (e.Metrics.confidence = h.pdf417.confidence),
          (e.Metrics.isPortrait = h.pdf417.isPortrait),
          (e.Metrics.minWidth = h.pdf417.minWidth),
          (b.validateMinWidth = !1);
        var m = h.pdf417.confidence;
        MitekMobileWeb.logEvent(
          this.MitekMibiAction.CV_LANDSCAPE_PORTRAIT,
          MitekMobileWeb.convertBooleanToString(h.pdf417.isPortrait),
        ),
          MitekMobileWeb.logEvent(
            this.MitekMibiAction.CV_MEASURE_CONFIDENCE,
            MitekMobileWeb.convertNumberToString(m),
          ),
          b.validateConfidence &&
            (0 === e.errors.length && 0 >= m
              ? (console.warn('Confidence failed'),
                (e.errors = [MitekMobileWeb.MitekCaptureResult.IQA_NF]),
                MitekMobileWeb.logEvent(
                  MitekMobileWeb.MitekMibiAction.CV_ERROR_CONFIDENCE,
                  MitekMobileWeb.convertNumberToString(m),
                ))
              : m > 0 &&
                m < b.thresholds.CONFIDENCE &&
                (console.warn('Skew failed'),
                e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_SKEW),
                MitekMobileWeb.logEvent(
                  MitekMobileWeb.MitekMibiAction.CV_ERROR_SKEW,
                  MitekMobileWeb.convertNumberToString(m),
                ))),
          b.validateMinWidth &&
            void 0 !== h.pdf417.minWidth &&
            void 0 !== h.pdf417.isPortrait &&
            (MitekMobileWeb.logEvent(
              this.MitekMibiAction.CV_MEASURE_MIN_WIDTH,
              MitekMobileWeb.convertNumberToString(h.pdf417.minWidth),
            ),
            h.pdf417.isPortrait
              ? h.pdf417.minWidth < b.thresholds.WIDTH_FACTOR_PORTRAIT &&
                (console.warn('MinWidth Portrait failed'),
                e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINWIDTH),
                MitekMobileWeb.logEvent(
                  MitekMobileWeb.MitekMibiAction.CV_ERROR_TOO_FAR,
                  MitekMobileWeb.convertNumberToString(h.pdf417.minWidth),
                ))
              : h.pdf417.minWidth < b.thresholds.WIDTH_FACTOR_LANDSCAPE &&
                (console.warn('MinWidth Landscape failed'),
                e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_MINWIDTH),
                MitekMobileWeb.logEvent(
                  MitekMobileWeb.MitekMibiAction.CV_ERROR_TOO_FAR,
                  MitekMobileWeb.convertNumberToString(h.pdf417.minWidth),
                )));
        var n = new ImageData(a.data, a.width, a.height);
        MitekMobileWeb.processCVResult(e, h, b, a, c, d, n);
      } else {
        b.skipPDF417 ||
          (MitekMobileWeb.logEvent(
            this.MitekMibiAction.CV_NO_BARCODE_FOUND,
            this.MitekCaptureSession.MitekImageType,
          ),
          e.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_NF));
        var n = new ImageData(a.data, a.width, a.height);
        MitekMobileWeb.processCVResult(e, h, b, a, c, d, n);
      }
    },
    processCVResult: function (a, b, c, d, e, f, g) {
      a.errors.length > 0 &&
        (MitekMobileWeb.logEvent(
          this.MitekMibiAction.CV_ERROR_FAILURE,
          this.MitekCaptureSession.MitekImageType,
        ),
        (a.status = 'failure'));
      var h = new MitekMobileWeb.MitekCaptureResult.Result();
      (h.errors = a.errors), (h.status = a.status), (h.Metrics = a.Metrics);
      var i,
        j,
        k =
          null != this.MitekCaptureSession.CaptureParams.jpegEncodingQuality
            ? this.MitekCaptureSession.CaptureParams.jpegEncodingQuality
            : 70;
      if (((k = 0.01 * k), 'success' === h.status))
        if (
          (MitekMobileWeb.logEvent(
            this.MitekMibiAction.CV_ENCODING_QUALITY,
            MitekMobileWeb.convertNumberToString(k),
          ),
          c.documentType != MitekMobileWeb.MitekImageTypeCode.BARCODE_PDF417)
        )
          (i = { width: d.width, height: d.height, data: d.data }),
            (h.finalImage = this.convertImageDataToDataURL(d, k, c.encoding));
        else {
          j = this.mat2ImageData(a.image);
          var d = this.convertToImageData(j);
          (h.finalImage = this.convertImageDataToDataURL(d, k, c.encoding)),
            'undefined' != typeof g &&
              (h.fullColorImage = this.convertImageDataToDataURL(g, k, c.encoding));
        }
      else
        MitekMobileWeb.logEvent(
          this.MitekMibiAction.CV_ENCODING_QUALITY,
          MitekMobileWeb.convertNumberToString(k),
        ),
          (i = { width: d.width, height: d.height, data: d.data }),
          (h.finalImage = this.convertImageDataToDataURL(d, k, c.encoding));
      var l = new Date().getTime() - f;
      MitekMobileWeb.logEvent(
        this.MitekMibiAction.TOTAL_CV_TIME,
        MitekMobileWeb.convertNumberToString(l),
      ),
        'success' == a.status &&
          MitekMobileWeb.logEvent(
            this.MitekMibiAction.CV_SUCCESS,
            this.MitekCaptureSession.MitekImageType,
          );
      var m = 2 * h.finalImage.length;
      MitekMobileWeb.logEvent(this.MitekMibiAction.CV_FINAL_IMAGE_SIZE, m), e(h);
    },
    convertToImageData: function (a, b, c) {
      void 0 == b && (b = a.width), void 0 == c && (c = a.height);
      var d = document.createElement('canvas'),
        e = d.getContext('2d').createImageData(b, c);
      return e.data.set(a.data), e;
    },
    convertImageDataToDataURL: function (a, b, c) {
      var d = void 0 !== c ? c.toLowerCase() : 'jpeg',
        e = document.createElement('canvas');
      (e.width = a.width), (e.height = a.height), e.getContext('2d').putImageData(a, 0, 0);
      var f;
      (f = 'bmp' == d ? e.toDataURL('image/bmp') : e.toDataURL('image/jpeg', b)),
        this.addMibiDataToEXIFData(),
        (f = this.insertEXIFData(f, MitekMobileWeb.MitekCaptureSession.EXIFData));
      var g = f.split(','),
        h = g[1];
      return h;
    },
    convertDataURItoBlob: function (a, b) {
      for (
        var c = atob(a), d = new ArrayBuffer(c.length), e = new Uint8Array(d), f = 0;
        f < c.length;
        f++
      )
        e[f] = c.charCodeAt(f);
      var g = new DataView(d),
        h = new Blob([g], { type: b });
      return h;
    },
    convertFileToDataURL: function (a, b) {
      var c = new FileReader();
      c.addEventListener('loadend', function () {
        b(this.result);
      }),
        c.readAsDataURL(a);
    },
    addMibiDataToEXIFData: function () {
      if ('undefined' == typeof piexif)
        return void console.warn('EXIF library piexif.js not loaded');
      try {
        MitekMobileWeb.MitekCaptureSession.EXIFData.Exif[
          piexif.ExifIFD.UserComment
        ] = JSON.stringify(MitekMobileWeb.MitekMibiData);
      } catch (a) {
        console.warn('Unable to add MibiData to EXIF data');
      }
    },
    captureEXIFData: function (a) {
      return a.type.match('image/jpeg.*')
        ? 'undefined' == typeof piexif
          ? void console.warn('EXIF library piexif.js not loaded')
          : void this.convertFileToDataURL(a, this.saveEXIFData)
        : void 0;
    },
    saveEXIFData: function (a) {
      if ('undefined' == typeof piexif)
        return void console.warn('EXIF library piexif.js not loaded');
      try {
        var b = piexif.load(a);
        MitekMobileWeb.MitekCaptureSession.EXIFData = b;
      } catch (c) {
        console.warn('Unable to load EXIF data: ' + c);
      }
    },
    insertEXIFData: function (a, b) {
      if ('undefined' == typeof piexif) return a;
      try {
        var c = piexif.dump(b);
        a = piexif.insert(c, a);
      } catch (d) {
        console.warn('Unable to insert EXIF data: ' + d);
      }
      return a;
    },
    encodeRawImage: function (a, b) {
      var c = new Date().getTime(),
        d = new Image(),
        e = document.createElement('canvas'),
        f = e.getContext('2d'),
        g = window.URL || window.webkitURL;
      if (g) {
        var h = g.createObjectURL(a),
          i = this;
        this.captureEXIFData(a),
          (d.onerror = function () {
            console.warn('Image load failed: image is corrupt');
            var a = new MitekMobileWeb.MitekCaptureResult.Result();
            a.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_CORRUPTIMAGE),
              (a.status = 'failure'),
              MitekMobileWeb.MitekCaptureSession.Callback(a);
          }),
          (d.onload = function () {
            var a =
                'document' == MitekMobileWeb.MitekCaptureSession.MitekImageType.toLowerCase()
                  ? MitekMobileWeb.CVDefaultThresholds.GLOBAL.maximumDefaultDocumentImageSize
                  : MitekMobileWeb.CVDefaultThresholds.GLOBAL.maximumDefaultImageSize,
              j = MitekMobileWeb.CVDefaultThresholds.GLOBAL.minimumImageSize,
              k =
                void 0 !== MitekMobileWeb.MitekCaptureSession.CaptureParams.maxImageSize
                  ? MitekMobileWeb.MitekCaptureSession.CaptureParams.maxImageSize
                  : a,
              l =
                void 0 !== MitekMobileWeb.MitekCaptureSession.CaptureParams.minImageSize
                  ? MitekMobileWeb.MitekCaptureSession.CaptureParams.minImageSize
                  : j,
              m = i.resizeImageCanvas(e, d, k, l);
            if (m === !1) {
              console.warn('Image resize failed: image is too small');
              var n = new MitekMobileWeb.MitekCaptureResult.Result();
              n.errors.push(MitekMobileWeb.MitekCaptureResult.IQA_IMAGETOOSMALL),
                (n.status = 'failure'),
                MitekMobileWeb.MitekCaptureSession.Callback(n);
            } else {
              f.drawImage(d, 0, 0, e.width, e.height);
              var o = f.getImageData(0, 0, e.width, e.height);
              g.revokeObjectURL(h);
              var p = new Date().getTime() - c;
              MitekMobileWeb.logEvent(
                MitekMobileWeb.MitekMibiAction.TOTAL_ENCODING_TIME,
                MitekMobileWeb.convertNumberToString(p),
              ),
                b(o);
            }
          }),
          (d.src = h);
      }
    },
    b64ToUint6: function (a) {
      return a > 64 && 91 > a
        ? a - 65
        : a > 96 && 123 > a
        ? a - 71
        : a > 47 && 58 > a
        ? a + 4
        : 43 === a
        ? 62
        : 47 === a
        ? 63
        : 0;
    },
    b64DecToArr: function (a, b) {
      for (
        var c,
          d,
          e = a.replace(/[^A-Za-z0-9\+\/]/g, ''),
          f = e.length,
          g = b ? Math.ceil(((3 * f + 1) >> 2) / b) * b : (3 * f + 1) >> 2,
          h = new Uint8Array(g),
          i = 0,
          j = 0,
          k = 0;
        f > k;
        k++
      )
        if (
          ((d = 3 & k),
          (i |= this.b64ToUint6(e.charCodeAt(k)) << (18 - 6 * d)),
          3 === d || f - k === 1)
        ) {
          for (c = 0; 3 > c && g > j; c++, j++) h[j] = (i >>> ((16 >>> c) & 24)) & 255;
          i = 0;
        }
      return h;
    },
    b64to8Arr: function (a) {
      return this.b64DecToArr(a);
    },
    base64EncodeImage: function (a, b) {
      return window.btoa(this.encodeImageData(a));
    },
    encodeImageData: function (a) {
      for (var b = 32768, c = [], d = 0; d < a.length; d += b)
        c.push(String.fromCharCode.apply(null, a.subarray(d, d + b)));
      return c.join('');
    },
    processImage: function (a, b) {
      this.captureImage(a);
    },
    processCapturedImage: function (a) {
      null !== this.MitekCaptureSession.CVStartCallback &&
        this.MitekCaptureSession.CVStartCallback();
      var b = a.files[0];
      this.MitekCaptureSession.ProcessImageCallback(b);
    },
    captureAndProcessImage: function (a, b, c, d) {
      void 0 !== d
        ? (this.MitekCaptureSession.CVStartCallback = d)
        : (this.MitekCaptureSession.CVStartCallback = null),
        'Desktop' == MitekMobileWeb.MitekMibiData.ImageSource.Platform
          ? (MitekMobileWeb.MitekMibiData.ImageSource.Upload = 'true')
          : (MitekMobileWeb.MitekMibiData.ImageSource.Upload = 'false'),
        (this.MitekCaptureSession.MitekImageType = b),
        MitekMobileWeb.logEvent(this.MitekMibiAction.PICTURE_CAPTURED, b);
      this.getImageTypeCode(b);
      (this.MitekCaptureSession.Callback = a),
        MitekMobileWeb.initCaptureSession(b, c),
        this.captureImage(this.processImageFromCapture);
    },
    processImageFromCapture: function (a) {
      MitekMobileWeb.encodeRawImage(a, MitekMobileWeb.processEncodedImage);
    },
    processEncodedImage: function (a) {
      var b = MitekMobileWeb.getCaptureSession();
      MitekMobileWeb.runIQA(a, b, MitekMobileWeb.MitekCaptureSession.Callback);
    },
    convertToKeyValuePairs: function (a) {
      var b,
        c = '',
        d = {},
        e = [];
      for (b in a)
        (c = '{"Key": "' + b + '", "Value": "' + a[b] + '"}'), (d = JSON.parse(c)), e.push(d);
      return e;
    },
    logEvent: function (a, b) {
      if (!a || !b)
        return void console.warn(
          'Unable to log event.  Please specify both event and eventValues.',
        );
      var c = new Date().getTime() - this.mibiStartTime,
        d = [];
      b instanceof Array ? (d = b) : d.push(b),
        d.unshift(c),
        '' == MitekMobileWeb.MitekMibiData.UserAgent && this.initConfig();
      var e = {};
      (e[a] = d), MitekMobileWeb.MitekMibiData.UXP.push(e);
    },
    initConfig: function () {
      MitekMobileWeb.MitekMibiData.UserAgent = navigator.userAgent;
      try {
        MitekRequiredFields &&
          (MitekMobileWeb.MitekMibiData.Parameters.MitekRequiredFields = MitekRequiredFields.join()),
          MitekExclusionConfig &&
            ((MitekMobileWeb.MitekMibiData.Parameters.onlyIOSandAndroidSupported = this.convertBooleanToString(
              MitekExclusionConfig.onlyIOSandAndroidSupported,
            )),
            (MitekMobileWeb.MitekMibiData.Parameters.onlyAndroidChromeSupported = this.convertBooleanToString(
              MitekExclusionConfig.onlyAndroidChromeSupported,
            )),
            (MitekMobileWeb.MitekMibiData.Parameters.MinimumAndroidVersion = this.convertNumberToString(
              MitekExclusionConfig.MinimumAndroidVersion,
            )),
            (MitekMobileWeb.MitekMibiData.Parameters.MinimumAndroidChromeVersion = this.convertNumberToString(
              MitekExclusionConfig.MinimumAndroidChromeVersion,
            )),
            (MitekMobileWeb.MitekMibiData.Parameters.AndroidExclusionList = MitekExclusionConfig.AndroidExclusionList.join()));
      } catch (a) {}
    },
    convertBooleanToString: function (a) {
      return a ? (a ? 'true' : 'false') : 'undefined';
    },
    convertNumberToString: function (a) {
      return '' + a;
    },
    getImageTypeCode: function (a, b) {
      if (void 0 == a || null == a)
        return console.log('Processing Image Type: n/a'), MitekMobileWeb.MitekImageTypeCode.OTHER;
      'undefined' == typeof b && console.log('Processing Image Type: ' + a), (a = a.toLowerCase());
      var c = '';
      return (
        'dl_front' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.ID)
          : 'dl_back' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.BARCODE_PDF417)
          : 'passport' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.PASSPORT)
          : 'check' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.CHECK)
          : 'vin' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.VIN)
          : 'document' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.DOCUMENT)
          : 'selfie' == a
          ? (c = MitekMobileWeb.MitekImageTypeCode.SELFIE)
          : 'other' == a && (c = MitekMobileWeb.MitekImageTypeCode.OTHER),
        '' == c &&
          (console.warn(
            'Invalid Document Type passed in: ' +
              a +
              ' | Valid Document Types are ("DL_Front", "DL_Back", "Passport", "Check", "Selfie", "Other")',
          ),
          (c = MitekMobileWeb.MitekImageTypeCode.OTHER)),
        c
      );
    },
    resizeImageCanvas: function (a, b, c, d) {
      var e = !0,
        f = Math.max(b.width, b.height);
      if ('undefined' != typeof d && d > f) return !1;
      if (f > c) {
        if (b.width > b.height) {
          var g = b.width / b.height;
          (a.width = c), (a.height = a.width / g);
        } else {
          var g = b.height / b.width;
          (a.height = c), (a.width = a.height / g);
        }
        console.log('Image exceeds ' + c + 'px | Resizing image to: ' + a.width + ' x ' + a.height);
      } else (a.width = b.width), (a.height = b.height);
      return e;
    },
    captureDocument: function (a) {
      void 0 === a.cvParams && (a.cvParams = null),
        void 0 === a.cvStartCallback && (a.cvStartCallback = null),
        this.captureAndProcessImage(a.callback, a.documentType, a.cvParams, a.cvStartCallback);
    },
    decodeCaptureErrorCodes: function (a) {
      for (var b = [], c = 0; c < a.length; c++)
        switch (a[c]) {
          case this.captureErrorCode.NF:
            b.push('We were unable to read your document.');
            break;
          case this.captureErrorCode.OOF:
            b.push('The image is too blurry.');
            break;
          case this.captureErrorCode.DARK:
            b.push('There is not enough light on your document.');
            break;
          case this.captureErrorCode.MINFILL:
            b.push('Move the camera closer to your document.');
            break;
          case this.captureErrorCode.SKEW:
            b.push('Hold camera directly over your document.');
            break;
          case this.captureErrorCode.MINWIDTH:
            b.push('Move the camera closer to your document.');
            break;
          case this.captureErrorCode.GLARE:
            b.push('Too much glare on your image.  Avoid bright lights.');
            break;
          case this.captureErrorCode.FOURCORNERS:
            b.push('We were unable to detect the four corners of your document.');
            break;
          case this.captureErrorCode.IQA_CORRUPTIMAGE:
            b.push('We were unable to proces the image you provided.');
            break;
          case this.captureErrorCode.IQA_LOWCONTRAST:
            b.push('Center your document on a dark background.');
            break;
          case this.captureErrorCode.IQA_BUSYBACKGROUND:
            b.push('The background is too busy.  Please use a solid background.');
            break;
          case this.captureErrorCode.IQA_IMAGETOOSMALL:
            b.push('The image you provided is too small');
        }
      return b;
    },
    getUserMediaSupported: function () {
      return navigator.mediaDevices && 'function' == typeof navigator.mediaDevices.getUserMedia;
    },
    showFullScreen: function () {
      screenfull.enabled && screenfull.request();
    },
    exitFullScreen: function () {
      screenfull.enabled && screenfull.exit();
    },
    getImageWithGlare: function (a, b, c, d) {
      (c = c ? c : 'red'), (d = d ? d : 5);
      var e = 'data:image/jpeg;base64,' + b.finalImage,
        f = new Image();
      (f.onload = function () {
        var e = document.createElement('canvas');
        (e.width = this.width), (e.height = this.height);
        var f = e.getContext('2d');
        this.width, this.height;
        if ((f.drawImage(this, 0, 0), void 0 != b.Metrics.glareLeft)) {
          var g = b.Metrics.glareLeft - b.Metrics.glareRight,
            h = b.Metrics.glareTop - b.Metrics.glareBottom;
          f.beginPath(),
            f.rect(b.Metrics.glareRight, b.Metrics.glareBottom, g, h),
            (f.lineWidth = d),
            (f.strokeStyle = c),
            f.stroke();
        }
        a(e.toDataURL('image/jpeg'));
      }),
        (f.src = e);
    },
    determineAspectRatios: function (a) {
      var b = {},
        c = {},
        d = {},
        e = {};
      (b.x = a.ax),
        (b.y = a.ay),
        (c.x = a.bx),
        (c.y = a.by),
        (d.x = a.cx),
        (d.y = a.cy),
        (e.x = a.dx),
        (e.y = a.dy);
      var f = Math.sqrt(
          Math.abs(b.y - c.y) * Math.abs(b.y - c.y) + Math.abs(b.x - c.x) * Math.abs(b.x - c.x),
        ),
        g = Math.sqrt(
          Math.abs(c.y - d.y) * Math.abs(c.y - d.y) + Math.abs(c.x - d.x) * Math.abs(c.x - d.x),
        ),
        h = Math.sqrt(
          Math.abs(d.y - e.y) * Math.abs(d.y - e.y) + Math.abs(d.x - e.x) * Math.abs(d.x - e.x),
        ),
        i = Math.sqrt(
          Math.abs(e.y - b.y) * Math.abs(e.y - b.y) + Math.abs(e.x - b.x) * Math.abs(e.x - b.x),
        ),
        j = [f, g, h, i];
      j.sort(function (a, b) {
        return b - a;
      }).slice(1);
      var k = j[0],
        l = j[2],
        m = j[3],
        n = k / l,
        o = k / m,
        p = { actualAspectRatio1: n, actualAspectRatio2: o };
      return p;
    },
    testAspectRatio: function (a, b, c) {
      var d = { passed: !0, error: '' },
        e = Math.abs(b - a.actualAspectRatio1),
        f = Math.abs(b - a.actualAspectRatio2);
      return (
        e > c
          ? ((d.passed = !1),
            (d.error =
              'Aspect Ratio failed - aspectRatioVariance1: ' + e + ' | aspectRatioThreshold: ' + c))
          : f > c &&
            ((d.passed = !1),
            (d.error =
              'Aspect Ratio failed - aspectRatioVariance2: ' +
              f +
              ' | aspectRatioThreshold: ' +
              c)),
        d
      );
    },
    getFileSize: function (a) {
      if (!a) return 0;
      var b = atob(a),
        c = b.length;
      return c;
    },
  };
  MitekMobileWeb.mitekWorker = MitekMobileWeb.getWorker();
  var MitekMibiAction = MitekMobileWeb.MitekMibiAction,
    mcv = mcv || { REVISION: 'ALPHA' };
  !(function (a) {
    (a.HOUGH_METHODS = { STANDARD: 0, PROBABILISTIC: 1, MULTI_SCALE: 2 }),
      (a.DETECTION_METHODS = {
        CONNECTED_COMPONENTS: 0,
        HOUGH_TRANSFORM: 1,
      }),
      (a.COLOR_RGBA2GRAY = 0),
      (a.COLOR_RGB2GRAY = 1),
      (a.COLOR_BGRA2GRAY = 2),
      (a.COLOR_BGR2GRAY = 3),
      (a.CALIPERS_MODES = {
        CALIPERS_MAXHEIGHT: 0,
        CALIPERS_MINAREARECT: 1,
      }),
      (a.clamp = function (a, b, c) {
        return Math.min(c, Math.max(b, a));
      }),
      (a.Image = function (a, b, c) {
        var d = this;
        (this.width = a || 0),
          (this.height = b || 0),
          (this.data = c || []),
          (this.get = function (a, b) {
            return d.data[b * d.width + a];
          }),
          (this.set = function (a, b, c) {
            d.data[b * d.width + a] = c;
          });
      });
  })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        var a = [0, 3, 5, 7, 11, 15],
          b = function (a, b, c) {
            var d = null;
            if (c.isSharpnessOn || c.isBrightnessOn) {
              d = {};
              var e = mcv.imgproc.iqaMetrics(a.data, null, a.width, a.height, b);
              c.isSharpnessOn && (d.sharpness = Math.min(e.highestLoG, 255) / 255),
                c.isBrightnessOn && (d.brightness = e.mean / 255);
            }
            return d;
          },
          c = function (a) {
            return a && a.confidence > 0.95;
          },
          d = function (a, b) {
            return a.minFill > 0.2 && a.minGap * Math.pow(2, b - 1) > 25;
          },
          e = function (a, b) {
            for (var c = a.length; --c >= 0; ) a[c] = b;
          },
          f = function (a, b) {
            mcv.transformation.rotateRight(a, b),
              (a.data = [b.data, (b.data = a.data)][0]),
              (a.width = [a.height, (a.height = a.width)][0]),
              (b.width = a.width),
              (b.height = a.height),
              e(b.data, 0);
          },
          g = function (a) {
            for (
              var b = [
                  { blockSizePower: 1 },
                  { blockSizePower: 2 },
                  { blockSizePower: 3 },
                  {
                    blockSizePower: 2,
                    barcodeMinHeight: 10,
                    rowStep: 5,
                    skippedRowCountMax: 100,
                  },
                ],
                c = [
                  {
                    start: [8, 1, 1, 1, 1, 1, 1, 3],
                    stop: [7, 1, 1, 3, 1, 1, 1, 2],
                  },
                ],
                d = new mcv.Image(
                  a.width,
                  a.height,
                  new Uint8Array(new ArrayBuffer(a.width * a.height)),
                ),
                e = null,
                g = 0;
              g < c.length;
              g++
            )
              for (var h = c[g], i = 0; i < b.length; i++)
                if ((mcv.pdf417Detector.init(b[i]), null == e || null == e.contour))
                  for (var j = 0; 4 > j; j++) {
                    if (((e = mcv.pdf417Detector.detect(a, d, h.start, h.stop)), e && e.contour))
                      return e;
                    f(a, d);
                  }
            return null;
          },
          h = function (a, b) {
            if (a.iqa && a.iqa.brightness) {
              if (a.iqa && a.iqa.sharpness && a.iqa.brightness > 0.3) {
                var c = new mcv.Image(
                  a.gray.width,
                  a.gray.height,
                  new Uint8Array(new ArrayBuffer(a.gray.width * a.gray.height)),
                );
                (b.sharpenStrength = b.sharpenStrength || 0.05),
                  mcv.imgproc.sharpen(
                    a.gray.data,
                    c.data,
                    a.gray.width,
                    a.gray.height,
                    b.sharpenStrength,
                  ),
                  (a.gray = c);
              }
              mcv.imgproc.enhance_contrast(a.gray, 255 * a.iqa.brightness, a.iqa.brightness);
            }
          };
        return {
          analyze4Corners: function (e, f) {
            var g = {};
            f = f || {};
            var h = new mcv.Image();
            if ((mcv.imgproc.grayscale(e, h), f.skip4Corners !== !0)) {
              var i = { confidence: -1 },
                j = e.width <= 1920 ? 2 : 3,
                k = mcv.imgproc.pyramid(h, j),
                l = new mcv.Image(k.data[j - 1].cols, k.data[j - 1].rows, k.data[j - 1].data);
              CV.stackBoxBlur(l, l, 5);
              for (var m = 0, n = a.length; n > m; m++) {
                var o = mcv.detector.detectDocument(l, mcv.DETECTION_METHODS.CONNECTED_COMPONENTS, {
                  kernelSize: f.kernelSize,
                  threshold: a[m],
                });
                if ((o.confidence > i.confidence && d(o, j) && (i = o), c(i))) break;
              }
              if (i && i.contour) {
                var p;
                for (p = 0; p < i.contour.length; ++p)
                  (i.contour[p].x *= Math.pow(2, j - 1)), (i.contour[p].y *= Math.pow(2, j - 1));
                i.minGap *= Math.pow(2, j - 1);
              }
              var q = h;
              i &&
                i.contour &&
                ((q = new mcv.Image()), mcv.transformation.perspectiveWarp(h, q, i.contour)),
                (g.iqa = b(h, i && i.contour ? i.bbox : null, f)),
                (g.corners = i),
                (g.gray = q);
            } else (g.iqa = b(h, null, f)), (g.gray = h);
            return g;
          },
          analyzePDF417: function (a, c) {
            var d = {};
            c = c || {};
            var e = new mcv.Image();
            if ((mcv.imgproc.grayscale(a, e), c.skipPDF417 !== !0))
              if (((d.pdf417 = g(e)), d.pdf417 && d.pdf417.confidence > 0)) {
                (d.pdf417.isPortrait = a.width < a.height),
                  (d.pdf417.minWidth = (d.pdf417.bbox.right - d.pdf417.bbox.left) / e.width);
                var f = new mcv.Image();
                mcv.transformation.perspectiveWarpSimple(e, f, d.pdf417.contour),
                  (d.gray = f),
                  (d.iqa = b(d.gray, null, c)),
                  h(d, c);
              } else d.gray = e;
            else d.gray = e;
            return (d.iqa = b(d.gray, null, c)), d;
          },
        };
      })();
      a.analyzer = b;
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        var a = null,
          b = function (a, b) {
            for (var c = 0, d = ''; b > c; c++) d += String.fromCharCode((a >> (8 * c)) & 255);
            return d;
          },
          c = function (a, b) {
            var c,
              d = 1 << a,
              e = b ? 255 : 0,
              f = '';
            for (c = 0; d > c; c++) {
              var g = ((255 * c) / (d - 1)) ^ e;
              (f += String.fromCharCode(g)),
                (f += String.fromCharCode(g)),
                (f += String.fromCharCode(g)),
                (f += String.fromCharCode(0));
            }
            return f;
          },
          d = function (a, b, c, d, e, f, g) {
            var h,
              i,
              j,
              k,
              l,
              m,
              n,
              o,
              p,
              q,
              r,
              s,
              t,
              u,
              v,
              w,
              x,
              y = 0,
              z = e[0][0],
              A = e[0][1],
              B = e[0][2],
              C = e[1][0],
              D = e[1][1],
              E = e[1][2],
              F = e[2][0],
              G = e[2][1],
              H = e[2][2],
              I = 1 / 0,
              J = -(1 / 0);
            for (o = 0; d > o; ++o)
              for (
                h = o * c, i = 1 > o ? h : h - c, j = o >= d - 1 ? h : h + c, n = 0;
                c > n;
                ++n
              ) {
                (k = n),
                  (l = 1 > n ? k : k - 1),
                  (m = n >= c - 1 ? k : k + 1),
                  (p = i + l),
                  (q = i + k),
                  (r = i + m),
                  (s = h + l),
                  (t = h + k),
                  (u = h + m),
                  (v = j + l),
                  (w = j + k),
                  (x = j + m);
                var K =
                  a[p] * z +
                  a[q] * A +
                  a[r] * B +
                  a[s] * C +
                  a[t] * D +
                  a[u] * E +
                  a[v] * F +
                  a[w] * G +
                  a[x] * H;
                f > K && (K = f),
                  K > g && (K = g),
                  (b[y++] = K),
                  (I = Math.min(I, Math.abs(K))),
                  (J = Math.max(J, Math.abs(K)));
              }
            return { min: I, max: J };
          },
          e = function (a, b, c, d) {
            var e,
              f,
              g,
              h,
              i = a.data,
              j = b.data,
              k = a.width,
              l = a.height,
              m = 0;
            d = d || [-k - 1, -k, -k + 1, -1, 1, k - 1, k, k + 1];
            var n = d.length;
            for (f = 0; k > f; ++f) j[m++] = 0;
            for (f = 2; l > f; ++f) {
              for (j[m++] = 0, g = 2; k > g; ++g) {
                for (e = i[m], h = 0; n > h; ++h) e = c(e, i[m + d[h]]);
                j[m++] = e;
              }
              j[m++] = 0;
            }
            for (f = 0; k > f; ++f) j[m++] = 0;
            return (b.width = a.width), (b.height = a.height), b;
          },
          f = function (a, b, c, d, e) {
            var f,
              g,
              h,
              i,
              j,
              k,
              l,
              m,
              n,
              o,
              p,
              q,
              r,
              s = 1,
              t = 1,
              u = -4,
              v = 1,
              w = 1,
              x = -(1 / 0),
              y = 0;
            (e = e || {}),
              (e.top = e.top || 0),
              (e.left = e.left || 0),
              (e.bottom = e.bottom || d),
              (e.right = e.right || c);
            var z = 3;
            for (m = e.top + z; m < e.bottom - z; ++m)
              for (
                f = m * c, g = 1 > m ? f : f - c, h = m >= d - 1 ? f : f + c, l = e.left + z;
                l < e.right - z;
                ++l
              ) {
                (i = l),
                  (j = 1 > l ? i : i - 1),
                  (k = l >= c - 1 ? i : i + 1),
                  (n = g + i),
                  (o = f + j),
                  (p = f + i),
                  (q = f + k),
                  (r = h + i);
                var A = Math.abs(a[n] * s + a[o] * t + a[p] * u + a[q] * v + a[r] * w);
                A > x && (x = A), (y += a[p]);
              }
            return {
              highestLoG: x,
              mean: y / ((e.right - e.left) * (e.bottom - e.top)),
            };
          },
          g = function (a, b) {
            return e(a, b, Math.min);
          },
          h = function (a, b) {
            return e(a, b, Math.max);
          };
        return {
          iqaMetrics: f,
          convolve3x3: d,
          erode: g,
          dilate: h,
          sharpen: function (a, b, c, e, f) {
            var g = -f;
            d(
              a,
              b,
              c,
              e,
              [
                [g, g, g],
                [g, 1 - 7 * g, g],
                [g, g, g],
              ],
              0,
              255,
            );
          },
          houghTransforms: function (a, b, c, d, e, f, g) {
            var h = null;
            try {
              if (null == a) return h;
              null == f && (f = 0), null == g && (g = 0), (h = []);
              var i,
                j,
                k,
                l,
                m = Math.floor(Math.PI / d),
                n = new Array(m),
                o = new Array(m),
                p = new Array(m),
                q = Math.floor(Math.sqrt(a.cols * a.cols + a.rows * a.rows) + 0.5);
              for (i = 0; i < p.length; i++)
                for (p[i] = new Array(2 * q), j = 0; j < p[i].length; j++) p[i][j] = 0;
              for (i = 0; i < n.length; i++) (n[i] = Math.sin(i * d)), (o[i] = Math.cos(i * d));
              switch (b) {
                case mcv.HOUGH_METHODS.STANDARD:
                  for (i = 0; i < a.rows; i++) {
                    var r = i * a.cols * a.channel,
                      s = 0;
                    for (j = 0; j < a.cols; j++) {
                      if (255 === a.data[s + r])
                        for (k = 0; m > k; k++)
                          (l = Math.floor(j * o[k] + i * n[k] + 0.5)), p[k][l + q]++;
                      s += a.channel;
                    }
                  }
                  break;
                case mcv.HOUGH_METHODS.PROBABILISTIC:
                  break;
                case mcv.HOUGH_METHODS.MULTI_SCALE:
              }
              var t = 0;
              for (k = 0; k < p.length; k++)
                for (l = 0; l < p[k].length; l++) p[k][l] > e && ((h[t] = [l - q, k]), t++);
            } catch (u) {
              alert('cvHoughLines2 : ' + u);
            }
            return h;
          },
          grayscale: function (a, b) {
            for (
              var c = a.data,
                d = c.length,
                e = 0,
                f = 0,
                g = new Uint8Array(new ArrayBuffer(a.width * a.height)),
                h = Math.round(d / (a.width * a.height));
              d > e;
              e += h
            ) {
              var i = 0.2126 * c[e] + 0.7152 * c[e + 1] + 0.0722 * c[e + 2];
              g[f++] = Math.round(Math.min(255, i));
            }
            return (b.data = g), (b.width = a.width), (b.height = a.height), b;
          },
          enhance_contrast: function (a, b, c, d) {
            for (
              var e, f = a.data, g = f.length, h = 0, i = Math.round(g / (a.width * a.height));
              g > h;
              h += i
            )
              (e = f[h]),
                0.6 > c && e > b && (e += 20 + 60 * (1 - c)),
                c > 0.3 && b > e && (e -= 15 + 20 * c),
                (f[h] = mcv.clamp(Math.round(e), 0, 255));
          },
          pyrdown: function (a, b, c, d) {
            'undefined' == typeof c && (c = 0), 'undefined' == typeof d && (d = 0);
            var e = a.width,
              f = a.height,
              g = e >> 1,
              h = f >> 1,
              i = g - (c << 1),
              j = h - (d << 1),
              k = 0,
              l = 0,
              m = c + d * e,
              n = 0,
              o = 0,
              p = 0;
            (b.width = g), (b.height = h);
            var q = a.data,
              r = b.data;
            for (l = 0; j > l; ++l) {
              for (n = m, p = o, k = 0; i - 2 >= k; k += 2, p += 2, n += 4)
                (r[p] = (q[n] + q[n + 1] + q[n + e] + q[n + e + 1] + 2) >> 2),
                  (r[p + 1] = (q[n + 2] + q[n + 3] + q[n + e + 2] + q[n + e + 3] + 2) >> 2);
              for (; i > k; ++k, ++p, n += 2)
                r[p] = (q[n] + q[n + 1] + q[n + e] + q[n + e + 1] + 2) >> 2;
              (m += e << 1), (o += g);
            }
          },
          minMaxLoc: function (a) {
            for (var b, c = a.data, d = c.length, e = 0, f = 1 / 0, g = -(1 / 0); d > e; e++)
              (b = c[e]), f > b && (f = b), b > g && (g = b);
            return { min: f, max: g };
          },
          pyramid: function (b, c) {
            var d = b.width,
              e = b.height,
              f = jsfeat.U8_t | jsfeat.C1_t;
            null == a && ((a = new jsfeat.pyramid_t(c)), a.allocate(d, e, f));
            var g = new jsfeat.matrix_t(d, e, jsfeat.U8_t | jsfeat.C1_t, {
              u8: b.data,
            });
            return a.build(g, !0), a;
          },
          box_blur_gray: function (a, b) {
            var c = new jsfeat.matrix_t(a.width, a.height, jsfeat.U8_t | jsfeat.C1_t, {
              u8: a.data,
            });
            jsfeat.imgproc.box_blur_gray(c, c, b);
          },
          encodeBitmap: function (a, d) {
            var e = a.width,
              f = a.height,
              g = a.data,
              h = 1;
            'rgb' == d && (h = 3);
            var i = (e * h + 3) & -4,
              j = 40,
              k = h > 1 ? 0 : 1024,
              l = 14 + j + k,
              m = i * f + l,
              n = '';
            (n += 'BM'),
              (n += b(m, 4)),
              (n += b(0, 4)),
              (n += b(l, 4)),
              (n += b(j, 4)),
              (n += b(e, 4)),
              (n += b(f, 4)),
              (n += b(1, 2)),
              (n += b(h << 3, 2)),
              (n += b(0, 4)),
              (n += b(0, 4)),
              (n += b(0, 4)),
              (n += b(0, 4)),
              (n += b(0, 4)),
              (n += b(0, 4)),
              1 == h && (n += c(8)),
              (e *= h);
            var o, p, q;
            for (o = f - 1; o >= 0; --o) {
              for (q = o * e, p = 0; e > p; ++p) n += String.fromCharCode(g[q + p]);
              for (p = 0; i - e > p; p++) n += String.fromCharCode(0);
            }
            for (var r = new Uint8Array(new ArrayBuffer(n.length)), s = 0, t = n.length; t > s; s++)
              r[s] = n.charCodeAt(s);
            return r;
          },
          close: function (a) {
            var b = new mcv.Image(
              a.width,
              a.height,
              new Uint8Array(new ArrayBuffer(a.width * a.height)),
            );
            h(a, b), g(b, a);
          },
        };
      })();
      a.imgproc = b;
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        var a = function (a, b, c, d) {
            var e,
              f,
              g,
              h = [],
              i = a.length;
            for (g = 0; i > g; ++g)
              (e = a[g]),
                e.length >= b &&
                  ((f = CV.approxPolyDP(e, e.length * c)),
                  4 === f.length &&
                    CV.isContourConvex(f) &&
                    CV.minEdgeLength(f) >= d &&
                    ((f.data = e), h.push(f)));
            return h;
          },
          b = function (a) {
            var b,
              c,
              d,
              e,
              f,
              g,
              h = a.length;
            for (g = 0; h > g; ++g)
              (b = a[g][1].x - a[g][0].x),
                (d = a[g][1].y - a[g][0].y),
                (c = a[g][2].x - a[g][0].x),
                (e = a[g][2].y - a[g][0].y),
                0 > b * e - d * c && ((f = a[g][1]), (a[g][1] = a[g][3]), (a[g][3] = f));
            return a;
          },
          c = function (a, b) {
            var c,
              d,
              e,
              f,
              g,
              h,
              i = [],
              j = a.length;
            for (f = 0; j > f; ++f)
              for (g = f + 1; j > g; ++g) {
                for (c = 0, h = 0; 4 > h; ++h)
                  (d = a[f][h].x - a[g][h].x), (e = a[f][h].y - a[g][h].y), (c += d * d + e * e);
                b * b > c / 4 &&
                  (CV.perimeter(a[f]) < CV.perimeter(a[g])
                    ? (a[f].tooNear = !0)
                    : (a[g].tooNear = !0));
              }
            for (f = 0; j > f; ++f) a[f].tooNear || i.push(a[f]);
            return i;
          },
          d = function (a, b) {
            for (var c, d = a.length, e = 0, f = -(1 / 0), g = null; d > e; ++e)
              (c = mcv.geometry.area_quadix(a[e])), c >= b && c > f && ((f = c), (g = a[e]));
            return g;
          },
          e = function (a, b) {
            if (null == a) return null;
            var c,
              d = [],
              e = null,
              f = null,
              g = null,
              h = null;
            for (c = 0; c < a.length; c++) {
              var i = new mcv.geometry.line(a[c][0], a[c][1]);
              i.isHorizontal() &&
                ((null == e || Math.abs(e.rho) > Math.abs(i.rho)) && (e = i),
                (null == g || Math.abs(g.rho) < Math.abs(i.rho)) && (g = i)),
                i.isVertical() &&
                  ((null == f || Math.abs(f.rho) > Math.abs(i.rho)) && (f = i),
                  (null == h || Math.abs(h.rho) < Math.abs(i.rho)) && (h = i)),
                b && d.push(i);
            }
            return { left: f, top: e, right: h, bottom: g, all: d };
          },
          f = function (e, f, g) {
            var h = new mcv.Image(),
              i = [],
              j = [],
              k = [];
            CV.adaptiveThreshold(e, h, f, g),
              (j = CV.findContours(h, i)),
              (k = a(j, 0.2 * e.width, 0.05, 10)),
              (k = b(k)),
              (k = c(k, 10));
            var l = d(k, e.width * e.height * 0.05);
            return { binary: h, contour: l };
          },
          g = function (a, b, c, d) {
            var f = new mcv.Image();
            CV.stackBoxBlur(a, f, b), (f.width = a.width), (f.height = a.height);
            var g = new jsfeat.matrix_t(f.width, f.height, jsfeat.U8_t | jsfeat.C1_t, {
              u8: f.data,
            });
            jsfeat.imgproc.canny(g, g, 0 | c, 0 | d), (f.data = g.data);
            var h = mcv.imgproc.houghTransforms(
                g,
                mcv.imgproc.HOUGH_METHODS.STANDARD,
                1,
                Math.PI / 180,
                75,
              ),
              i = e(h),
              j = null;
            return (
              i.top &&
                i.left &&
                i.bottom &&
                i.right &&
                ((j = []),
                j.push(mcv.geometry.intersect_line_2_line(i.top, i.left)),
                j.push(mcv.geometry.intersect_line_2_line(i.top, i.right)),
                j.push(mcv.geometry.intersect_line_2_line(i.bottom, i.right)),
                j.push(mcv.geometry.intersect_line_2_line(i.bottom, i.left))),
              { binary: f, contour: j }
            );
          },
          h = function (a, b, c, d) {
            var e = 0,
              f = 1 / 0;
            if (a && 4 == a.length) {
              b.left.x < f && (f = b.left),
                b.top < f && (f = b.top),
                c - b.right < f && (f = c - b.right),
                d - b.bottom < f && (f = d - b.bottom);
              for (var g = 0, h = 2; 5 > h; h++) {
                var i = Math.abs(mcv.geometry.angle_cos(a[h % 4], a[h - 2], a[h - 1]));
                i > g && (g = i);
              }
              e = 1 - g;
            }
            return {
              score: e,
              minGap: f,
              minFill: mcv.geometry.area_quadix(a) / (c * d),
            };
          };
        return {
          detectDocument: function (a, b, c) {
            var d = null;
            switch (b) {
              case mcv.DETECTION_METHODS.CONNECTED_COMPONENTS:
                var e = null == c.kernelSize ? 10 : c.kernelSize,
                  i = null == c.threshold ? 5 : c.threshold;
                d = f(a, e, i);
                break;
              case mcv.DETECTION_METHODS.HOUGH_TRANSFORM:
                null != c.kernelSize &&
                  null != c.lowThreshold &&
                  null != c.highThreshold &&
                  (d = g(a, c.kernelSize, c.lowThreshold, c.highThreshold));
            }
            if (d) {
              d.bbox = mcv.geometry.bbox(d.contour);
              var j = h(d.contour, d.bbox, a.width, a.height);
              (d.confidence = j.score), (d.minGap = j.minGap), (d.minFill = j.minFill);
            }
            return d;
          },
        };
      })();
      a.detector = b;
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        var a = (function () {
            function a(a, b) {
              (this.x = a), (this.y = b);
            }
            return (
              (a.prototype.min = function (a) {
                (this.x = Math.min(this.x, a.x)), (this.y = Math.min(this.y, a.y));
              }),
              (a.prototype.max = function (a) {
                (this.x = Math.max(this.x, a.x)), (this.y = Math.max(this.y, a.y));
              }),
              (a.prototype.midpoint = function (a) {
                return new mcv.geometry.point(0.5 * (this.x + a.x), 0.5 * (this.y + a.y));
              }),
              (a.prototype.clone = function () {
                return new mcv.geometry.point(this.x, this.y);
              }),
              (a.prototype.normalize = function () {
                var a = this.length();
                (this.x /= a), (this.y /= a);
              }),
              (a.prototype.normalized = function () {
                var a = new mcv.geometry.point(this.x, this.y);
                return a.normalize(), a;
              }),
              (a.prototype.negate = function () {
                (this.x = -this.x), (this.y = -this.y);
              }),
              (a.prototype.sqrLength = function () {
                return this.x * this.x + this.y * this.y;
              }),
              (a.prototype.length = function () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
              }),
              (a.prototype.scale = function (a) {
                (this.x *= a), (this.y *= a);
              }),
              (a.prototype.add = function (a) {
                (this.x += a.x), (this.y += a.y);
              }),
              (a.prototype.sub = function (a) {
                (this.x -= a.x), (this.y -= a.y);
              }),
              (a.prototype.diff = function (a) {
                return new mcv.geometry.point(this.x - a.x, this.y - a.y);
              }),
              (a.prototype.distance = function (a) {
                var b = this.x - a.x,
                  c = this.y - a.y;
                return Math.sqrt(b * b + c * c);
              }),
              (a.prototype.dot = function (a) {
                return this.x * a.x + this.y * a.y;
              }),
              (a.prototype.equals = function (a) {
                return this.x == a.x && this.y == a.y;
              }),
              (a.prototype.orthogonal = function () {
                return new mcv.geometry.point(this.y, -this.x);
              }),
              (a.prototype.distanceToLine = function (a, b) {
                var c = b.diff(a).sqrLength(),
                  d = ((this.x - a.x) * (b.x - a.x) + (this.y - a.y) * (b.y - a.y)) / c,
                  e = b.diff(a);
                e.scale(d);
                var f = a.clone();
                return f.add(e), this.distance(f);
              }),
              (a.prototype.round = function () {
                (this.x = Math.round(this.x)), (this.y = Math.round(this.y));
              }),
              a
            );
          })(),
          b = (function () {
            function a(a, f) {
              (this.rho = a),
                (this.theta = f),
                (d = Math.cos((Math.PI * f) / 180)),
                (e = Math.sin((Math.PI * f) / 180)),
                (b = d * a),
                (c = e * a),
                (this.p1 = new mcv.geometry.point(
                  Math.round(b + 1e3 * -e),
                  Math.round(c + 1e3 * d),
                )),
                (this.p2 = new mcv.geometry.point(
                  Math.round(b - 1e3 * -e),
                  Math.round(c - 1e3 * d),
                ));
            }
            var b,
              c,
              d,
              e,
              f = 2;
            return (
              (a.prototype.isVertical = function () {
                return this.theta <= f || this.theta >= 180 - f;
              }),
              (a.prototype.isHorizontal = function () {
                return this.theta >= 90 - f && this.theta <= 90 + f;
              }),
              (a.prototype.getY = function (a) {
                return c + a * d;
              }),
              (a.prototype.getX = function (a) {
                return b + a * -e;
              }),
              a
            );
          })(),
          c = function (a, b) {
            for (var c = b, d = -1, e = b.x, f = b.y, g = 0; g < a.length; g++) {
              var h = a[g],
                i = e - h.x,
                j = f - h.y,
                k = i * i + j * j;
              k > d && ((d = k), (c = h));
            }
            return c;
          },
          d = function (a, b, c) {
            var d,
              e,
              f,
              g = b,
              h = 0,
              i = c,
              j = 0;
            if (c.x != b.x) {
              var k = (c.y - b.y) / (c.x - b.x),
                l = b.y - k * b.x,
                m = Math.sqrt(k * k + 1);
              for (d = 0; d < a.length; d++)
                (f = a[d]),
                  (e = (k * f.x + l - f.y) / m),
                  e > h && ((h = e), (g = f)),
                  j > e && ((j = e), (i = f));
            } else {
              var n = b.x;
              for (d = 0; d < a.length; d++)
                (f = a[d]), (e = n - f.x), e > h && ((h = e), (g = f)), j > e && ((j = e), (i = f));
            }
            return (
              (j = -j),
              {
                furthestPoint1: g,
                distance1: h,
                furthestPoint2: i,
                distance2: j,
              }
            );
          },
          e = function (a, b, c) {
            return (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);
          },
          f = function (a) {
            a.sort(function (a, b) {
              return a.x == b.x ? a.y - b.y : a.x - b.x;
            });
            var b,
              c = [];
            for (b = 0; b < a.length; b++) {
              for (; c.length >= 2 && e(c[c.length - 2], c[c.length - 1], a[b]) <= 0; ) c.pop();
              c.push(new mcv.geometry.point(a[b].x, a[b].y));
            }
            var d = [];
            for (b = a.length - 1; b >= 0; b--) {
              for (; d.length >= 2 && e(d[d.length - 2], d[d.length - 1], a[b]) <= 0; ) d.pop();
              d.push(new mcv.geometry.point(a[b].x, a[b].y));
            }
            return d.pop(), c.pop(), c.concat(d);
          };
        return {
          point: a,
          line: b,
          convexHull: f,
          closest_point_on_line_from_point: function (a, b, c) {
            var d = b.x - a.x,
              e = b.y - a.y,
              f = c.x - a.x,
              g = c.y - a.y,
              h = d * f + e * g,
              i = d * d + e * e,
              j = h / i,
              k = a.x + j * d,
              l = a.y + j * e;
            return new mcv.geometry.point(k, l);
          },
          distance_point_2_point: function (a, b) {
            var c = a.x - b.x,
              d = a.y - b.y;
            return Math.sqrt(c * c + d * d);
          },
          intersect_line_2_line: function (a, b) {
            var c = a.p1.x,
              d = a.p1.y,
              e = a.p2.x,
              f = a.p2.y,
              g = b.p1.x,
              h = b.p1.y,
              i = b.p2.x,
              j = b.p2.y,
              k = (c - e) * (h - j) - (d - f) * (g - i);
            return k
              ? new mcv.geometry.point(
                  ((c * f - d * e) * (g - i) - (c - e) * (g * j - h * i)) / k,
                  ((c * f - d * e) * (h - j) - (d - f) * (g * j - h * i)) / k,
                )
              : null;
          },
          area_quadix: function (a) {
            return a && 4 == a.length
              ? 0.5 *
                  (a[0].x * (a[1].y - a[3].y) +
                    a[1].x * (a[2].y - a[0].y) +
                    a[2].x * (a[3].y - a[1].y) +
                    a[3].x * (a[0].y - a[2].y))
              : NaN;
          },
          bbox: function (a) {
            var b = null;
            if (a && a.length >= 3) {
              for (var c = a[0].x, d = a[0].x, e = a[0].y, f = a[0].y, g = 1; g < a.length; ++g)
                a[g].x < c && (c = a[g].x),
                  a[g].y < e && (e = a[g].y),
                  a[g].x > d && (d = a[g].x),
                  a[g].y > f && (f = a[g].y);
              b = { left: c, top: e, right: d, bottom: f };
            }
            return b;
          },
          angle_cos: function (a, b, c) {
            var d = a.x - c.x,
              e = a.y - c.y,
              f = b.x - c.x,
              g = b.y - c.y;
            return (d * f + e * g) / Math.sqrt((d * d + e * e) * (f * f + g * g) + 1e-10);
          },
          angle_radians: function (a, b, c) {
            var d = Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2)),
              e = Math.sqrt(Math.pow(c.x - b.x, 2) + Math.pow(c.y - b.y, 2)),
              f = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
            return Math.acos((e * e + d * d - f * f) / (2 * e * d));
          },
          find_quadrilateral_corners: function (a) {
            var b = [];
            if (null == a || a.length < 4) return b;
            var e = mcv.geometry.bbox(a),
              f = new mcv.geometry.point(e.right - e.left, e.bottom - e.top),
              g = new mcv.geometry.point(e.left + f.x / 2, e.top + f.y / 2),
              h = (0.1 * (f.x + f.y)) / 2,
              i = c(a, g),
              j = c(a, i);
            b.push(new mcv.geometry.point(i.x, i.y)), b.push(new mcv.geometry.point(j.x, j.y));
            var k = d(a, i, j),
              l = k.furthestPoint1,
              m = k.furthestPoint2,
              n = k.distance1,
              o = k.distance2;
            if ((n >= h && o >= h) || (h > n && 0 !== n && h > o && 0 !== o))
              b.push(new mcv.geometry.point(l.x, l.y)), b.push(new mcv.geometry.point(m.x, m.y));
            else {
              var p = n > o ? l : m;
              (k = d(a, i, p)),
                (l = k.furthestPoint1),
                (m = k.furthestPoint2),
                (n = k.distance1),
                (o = k.distance2);
              var q = !1;
              if (
                (n >= h && o >= h
                  ? (mcv.geometry.distance_point_2_point(m, j) >
                      mcv.geometry.distance_point_2_point(l, j) && (l = m),
                    (q = !0))
                  : ((k = d(a, j, p)),
                    (l = k.furthestPoint1),
                    (m = k.furthestPoint2),
                    (n = k.distance1),
                    (o = k.distance2),
                    n >= h &&
                      o >= h &&
                      (mcv.geometry.distance_point_2_point(m, i) >
                        mcv.geometry.distance_point_2_point(l, i) && (l = m),
                      (q = !0))),
                q)
              ) {
                b.push(new mcv.geometry.point(l.x, l.y));
                var r;
                (k = d(a, i, l)),
                  (p = k.furthestPoint1),
                  (m = k.furthestPoint2),
                  (r = k.distance1),
                  (o = k.distance2),
                  o >= h && r >= h
                    ? mcv.geometry.distance_point_2_point(p, j) >
                        mcv.geometry.distance_point_2_point(m, j) && (m = p)
                    : ((k = d(a, j, l)),
                      (p = k.furthestPoint1),
                      (m = k.furthestPoint2),
                      (r = k.distance1),
                      (o = k.distance2),
                      mcv.geometry.distance_point_2_point(p, i) >
                        mcv.geometry.distance_point_2_point(m, i) &&
                        p != j &&
                        p != l &&
                        (m = p)),
                  m != i && m != j && m != l && b.push(new mcv.geometry.point(m.x, m.y));
              } else b.push(new mcv.geometry.point(p.x, p.y));
            }
            var s, t, u, v;
            for (s = 1, t = b.length; t > s; s++)
              (b[s].x < b[0].x || (b[s].x == b[0].x && b[s].y < b[0].y)) &&
                ((u = b[s]), (b[s] = b[0]), (b[0] = u));
            var w =
                b[1].x != b[0].x
                  ? (b[1].y - b[0].y) / (b[1].x - b[0].x)
                  : b[1].y > b[0].y
                  ? 1 / 0
                  : -(1 / 0),
              x =
                b[2].x != b[0].x
                  ? (b[2].y - b[0].y) / (b[2].x - b[0].x)
                  : b[2].y > b[0].y
                  ? 1 / 0
                  : -(1 / 0);
            if (
              (w > x && ((u = b[1]), (b[1] = b[2]), (b[2] = u), (v = w), (w = x), (x = v)),
              4 == b.length)
            ) {
              var y =
                b[3].x != b[0].x
                  ? (b[3].y - b[0].y) / (b[3].x - b[0].x)
                  : b[3].y > b[0].y
                  ? 1 / 0
                  : -(1 / 0);
              w > y && ((u = b[1]), (b[1] = b[3]), (b[3] = u), (v = w), (w = y), (y = v)),
                x > y && ((u = b[2]), (b[2] = b[3]), (b[3] = u), (v = x), (x = y), (y = v));
            } else b = [];
            return b;
          },
        };
      })();
      a.geometry = b;
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        return {
          perspectiveWarpSimple: function (a, b, c) {
            var d = !1;
            if (c && 4 == c.length) {
              var e = c[0],
                f = c[1],
                g = c[2],
                h = c[3],
                i = Math.round((f.x - e.x + (g.x - h.x)) / 2),
                j = Math.round((h.y - e.y + (g.y - f.y)) / 2),
                k = new jsfeat.matrix_t(a.width, a.height, jsfeat.U8_t | jsfeat.C1_t, {
                  u8: a.data,
                }),
                l = new jsfeat.matrix_t(i, j, jsfeat.U8_t | jsfeat.C1_t),
                m = new jsfeat.matrix_t(3, 3, jsfeat.F32_t | jsfeat.C1_t);
              jsfeat.math.perspective_4point_transform(
                m,
                e.x,
                e.y,
                0,
                0,
                f.x,
                f.y,
                i,
                0,
                g.x,
                g.y,
                i,
                j,
                h.x,
                h.y,
                0,
                j,
              ),
                jsfeat.matmath.invert_3x3(m, m),
                jsfeat.imgproc.warp_perspective(k, l, m, 0),
                (b.width = i),
                (b.height = j),
                (b.data = l.data),
                (d = !0);
            }
            return d;
          },
          perspectiveWarp: function (a, b, c) {
            var d = !1;
            if (c && 4 == c.length) {
              for (
                var e = null,
                  f = null,
                  g = null,
                  h = null,
                  i = new mcv.geometry.point(
                    (c[0].x + c[1].x + c[2].x + c[3].x) / 4,
                    (c[0].y + c[1].y + c[2].y + c[3].y) / 4,
                  ),
                  j = 0;
                j < c.length;
                j++
              ) {
                var k = c[j];
                k.y < i.y
                  ? ((e = null == e ? k : e.x > k.x ? k : e),
                    (f = null == f ? k : f.x < k.x ? k : f))
                  : ((g = null == g ? k : g.x > k.x ? k : g),
                    (h = null == h ? k : h.x < k.x ? k : h));
              }
              var l = Math.round((f.x - e.x + (h.x - g.x)) / 2),
                m = Math.round((g.y - e.y + (h.y - f.y)) / 2);
              (l -= l % 10), (m -= m % 10);
              var n = new jsfeat.matrix_t(a.width, a.height, jsfeat.U8_t | jsfeat.C1_t, {
                  u8: a.data,
                }),
                o = new jsfeat.matrix_t(l, m, jsfeat.U8_t | jsfeat.C1_t),
                p = new jsfeat.matrix_t(3, 3, jsfeat.F32_t | jsfeat.C1_t);
              jsfeat.math.perspective_4point_transform(
                p,
                e.x,
                e.y,
                0,
                0,
                f.x,
                f.y,
                l,
                0,
                h.x,
                h.y,
                l,
                m,
                g.x,
                g.y,
                0,
                m,
              ),
                jsfeat.matmath.invert_3x3(p, p),
                jsfeat.imgproc.warp_perspective(n, o, p, 0),
                (b.width = l),
                (b.height = m),
                (b.data = o.data),
                (d = !0);
            }
            return d;
          },
          rotateRight: function (a, b) {
            var c,
              d,
              e = a.width,
              f = a.height,
              g = a.data,
              h = b.data;
            for (d = 0; f > d; d++) for (c = 0; e > c; c++) h[c * f + (f - d - 1)] = g[d * e + c];
          },
        };
      })();
      a.transformation = b;
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
          var a = 1,
            b = 1 << a,
            c = b - 1,
            d = 5 * b,
            e = 24,
            f = function (e) {
              (a = e.blockSizePower || 2), (b = 1 << a), (c = b - 1), (d = 5 * b);
            },
            g = function (c, d, f, g, h) {
              for (var i = new Array(f), j = 0; f > j; j++) i[j] = new Array(d);
              for (var k = 0; f > k; k++) {
                var l = k << a,
                  m = h - b;
                l > m && (l = m);
                for (var n = 0; d > n; n++) {
                  var o = n << a,
                    p = g - b;
                  o > p && (o = p);
                  for (var q = 0, r = 255, s = 0, t = 0, u = l * g + o; b > t; t++, u += g) {
                    for (var v = 0; b > v; v++) {
                      var w = 255 & c[u + v];
                      (q += w), r > w && (r = w), w > s && (s = w);
                    }
                    if (s - r > e)
                      for (t++, u += g; b > t; t++, u += g)
                        for (var x = 0; b > x; x++) q += 255 & c[u + x];
                  }
                  var y = q >> (2 * a);
                  if (e >= s - r && ((y = r / 2), k > 0 && n > 0)) {
                    var z = (i[k - 1][n] + 2 * i[k][n - 1] + i[k - 1][n - 1]) / 4;
                    z > r && (y = z);
                  }
                  i[k][n] = y;
                }
              }
              return i;
            },
            h = function (a, b, c) {
              return b > a ? b : a > c ? c : a;
            },
            i = function (a, c, d, e, f, g) {
              for (var h, i = 0, j = d * f + c; b > i; i++, j += f)
                for (h = 0; b > h; h++)
                  if ((255 & a[j + h]) <= e) {
                    var k = g.width * (d + i) + c + h;
                    g.data[k] = 255;
                  }
            },
            j = function (c, d, e, f, g, j, k) {
              var l, m, n, o, p, q, r, s, t, u, v, w;
              for (l = 0; f > l; l++)
                for (m = l << a, n = j - b, m > n && (m = n), o = 0; e > o; o++) {
                  for (
                    p = o << a,
                      q = g - b,
                      p > q && (p = q),
                      s = h(o, 2, e - 3),
                      t = h(l, 2, f - 3),
                      u = 0,
                      r = -2;
                    2 >= r;
                    r++
                  )
                    (v = k[t + r]), (u += v[s - 2] + v[s - 1] + v[s] + v[s + 1] + v[s + 2]);
                  (w = u / 25), i(d, p, m, w, g, c);
                }
              return c;
            },
            k = function (b, e) {
              var f = b.width,
                h = b.height;
              if (f >= d && h >= d) {
                var i = b.data,
                  k = f >> a;
                0 !== (f & c) && k++;
                var l = h >> a;
                0 !== (h & c) && l++;
                var m = g(i, k, l, f, h);
                j(e, i, k, l, f, h, m);
              }
            };
          return { init: f, binarize: k };
        })(),
        c = (function () {
          var a = [0, 4, 1, 5],
            b = [6, 2, 7, 3],
            c = 0.42,
            d = 0.8,
            e = 3,
            f = 5,
            g = 60,
            h = 15,
            i = 20,
            j = function (a) {
              mcv.pdf417Binarizer.init(a),
                (g = a.skippedRowCountMax || 60),
                (h = a.rowStep || 15),
                (i = a.barcodeMinHeight || 20);
            },
            k = function (a, b, c) {
              for (var d = a.length, e = 0, f = 0, g = 0; d > g; g++) (e += a[g]), (f += b[g]);
              if (f > e) return 1 / 0;
              var h = e / f;
              c *= h;
              for (var i = 0, j = 0; d > j; j++) {
                var k = a[j],
                  l = b[j] * h,
                  m = k > l ? k - l : l - k;
                if (m > c) return 1 / 0;
                i += m;
              }
              return i / e;
            },
            l = function (a, b, f, g, h, i, j) {
              for (var l = 0; l < j.length; l++) j[l] = 0;
              for (
                var m = i.length, n = h, o = b, p = 0;
                0 !== a.data[f * g + o] && o > 0 && p++ < e;

              )
                o--;
              for (var q = o, r = 0; g > q; q++) {
                var s = 255 == a.data[f * g + q] ? 1 : 0;
                if (s ^ n) j[r]++;
                else {
                  if (r == m - 1) {
                    if (k(j, i, d) < c) return [o, q];
                    (o += j[0] + j[1]),
                      j.shift(),
                      j.shift(),
                      j.push(0),
                      j.push(0),
                      (j[m - 2] = 0),
                      (j[m - 1] = 0),
                      r--;
                  } else r++;
                  (j[r] = 1), (n = !n);
                }
              }
              return r == m - 1 && k(j, i, d) < c ? [o, q - 1] : null;
            },
            m = function (a, b, c, d, e, j) {
              for (
                var k = new Array(4), m = !1, n = new Array(j.length), o = null, p = null;
                b > d;
                d += h
              )
                if (((o = l(a, e, d, c, !1, j, n)), null != o)) {
                  for (; d > 0; ) {
                    if (((p = l(a, e, --d, c, !1, j, n)), null == p)) {
                      d++;
                      break;
                    }
                    o = p;
                  }
                  (k[0] = new mcv.geometry.point(o[0], d)),
                    (k[1] = new mcv.geometry.point(o[1], d)),
                    (m = !0);
                  break;
                }
              var q = d + 1;
              if (m) {
                var r = 0;
                for (p = [k[0].x, k[1].x]; b > q; q++)
                  if (
                    ((o = l(a, p[0], q, c, !1, j, n)),
                    null != o && Math.abs(p[0] - o[0]) < f && Math.abs(p[1] - o[1]) < f)
                  )
                    (p = o), (r = 0);
                  else {
                    if (r > g) break;
                    r++;
                  }
                (q -= r + 1),
                  (k[2] = new mcv.geometry.point(p[0], q)),
                  (k[3] = new mcv.geometry.point(p[1], q));
              }
              if (i > q - d) for (var s = 0; s < k.length; s++) k[s] = null;
              return k;
            },
            n = function (a, b, c) {
              for (var d = 0; d < c.length; d++) a[c[d]] = b[d];
            },
            o = function (c, d, e, f, g) {
              var h = c.height,
                i = c.width,
                j = new Array(8);
              return (
                n(j, m(c, h, i, d, e, f), a),
                null != j[4] && ((e = j[4].x), (d = j[4].y)),
                n(j, m(c, h, i, d, e, g), b),
                j
              );
            },
            p = function (a, b, c, d) {
              for (var e = [], f = 0, g = 0, i = !1; f < a.height; ) {
                var j = o(a, f, g, c, d);
                if (null != j[0] || null != j[3]) {
                  if (((i = !0), e.push(j), !b)) break;
                  null != j[2] ? ((g = j[2].x), (f = j[2].x)) : ((g = j[4].x), (f = j[4].x));
                } else {
                  if (!i) break;
                  (i = !1), (g = 0);
                  for (var k in e)
                    null != k[1] && (f = Math.max(f, k[1].y)),
                      null != k[3] && (f = Math.max(f, k[3].y));
                  f += h;
                }
              }
              return e;
            },
            q = function (a, b) {
              var c = 0;
              if (a && 4 == a.length) {
                for (var d = 0, e = 0; 4 > e; e++) {
                  var f = a[e],
                    g = 0 === e ? a[3] : a[e - 1],
                    h = a[(e + 1) % 4],
                    i = Math.abs(mcv.geometry.angle_cos(g, h, f));
                  i > d && (d = i);
                }
                c = 1 - d;
              }
              return c;
            },
            r = function (a, b, c, d, e, f, g) {
              var h,
                i,
                j,
                k,
                l,
                m = new mcv.geometry.point(-c.y, c.x),
                n = new mcv.geometry.point(c.y, -c.x);
              for (i = 0; i < d.vertical; i++) {
                for (
                  k = Math.round(b.y + c.y * i), j = Math.round(b.x + c.x * i), l = !0, h = 0;
                  h < d.horizontal;
                  h++
                )
                  if (g) {
                    var o = Math.round(k + n.y * h),
                      p = Math.round(j + n.x * h);
                    if (
                      o >= 0 &&
                      o < a.height &&
                      p >= 0 &&
                      p < a.width &&
                      a.data[o * a.width + p] > e
                    ) {
                      l = !1;
                      break;
                    }
                  } else {
                    var q = Math.round(k + m.y * h),
                      r = Math.round(j + m.x * h);
                    if (
                      q >= 0 &&
                      q < a.height &&
                      r >= 0 &&
                      r < a.width &&
                      a.data[q * a.width + r] > e
                    ) {
                      l = !1;
                      break;
                    }
                  }
                if (l) break;
              }
              var s = new mcv.geometry.point(j, k);
              return (
                g ? c.add(m) : c.add(n),
                c.normalize(),
                c.scale(f),
                s.add(c),
                s.round(),
                s.x < 0 && (s.x = 0),
                s.x >= a.width && (s.x = a.width - 1),
                s.y < 0 && (s.y = 0),
                s.y >= a.height && (s.y = a.height - 1),
                s
              );
            },
            s = function (a, b, c, d) {
              mcv.pdf417Binarizer.binarize(a, b);
              var e = p(b, !1, c, d),
                f = null,
                g = null,
                h = null,
                i = null,
                j = 0;
              if (
                e.length > 0 &&
                (e[0][0] &&
                  e[0][1] &&
                  e[0][4] &&
                  e[0][5] &&
                  ((g = []), g.push(e[0][0]), g.push(e[0][4]), g.push(e[0][5]), g.push(e[0][1])),
                e[0][2] &&
                  e[0][3] &&
                  e[0][6] &&
                  e[0][7] &&
                  ((h = []), h.push(e[0][6]), h.push(e[0][2]), h.push(e[0][3]), h.push(e[0][7])),
                g && h)
              ) {
                var k = g[0],
                  l = h[1],
                  m = h[2],
                  n = g[3],
                  o = 0,
                  s = 10,
                  t = { vertical: 250, horizontal: 45 },
                  u = r(b, k, k.diff(n).normalized(), t, o, s, !1),
                  v = r(b, l, l.diff(m).normalized(), t, o, s, !0),
                  w = r(b, m, m.diff(l).normalized(), t, o, s, !1),
                  x = r(b, n, n.diff(k).normalized(), t, o, s, !0);
                (f = [u, v, w, x]), (i = mcv.geometry.bbox(f)), (j = q(f));
              }
              return {
                binary: b,
                contour: f,
                confidence: j,
                startPattern: g,
                stopPattern: h,
                bbox: i,
              };
            };
          return { init: j, detect: s };
        })();
      (a.pdf417Binarizer = b), (a.pdf417Detector = c);
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        var a,
          b,
          c,
          d = function (a, b, c, d, e) {
            var f,
              g,
              h,
              i,
              j,
              k,
              l = Math.round(d / 2),
              m = Math.round(e / 2),
              n = l,
              o = a.height - m - 1,
              p = m,
              q = d * e;
            h = 0;
            var r, s, t, u;
            for (s = p; o >= s; s++) {
              for (i = j = 0, u = 0; e > u; u++)
                for (t = 0; d > t; t++) (k = a.get(t, s - m + u)), (i += k), (j += k * k);
              for (
                f = i / q,
                  g = Math.sqrt((j - (i * i) / q) / q),
                  g > h && (h = g),
                  b.set(n, s, f),
                  c.set(n, s, g),
                  r = 1;
                r <= a.width - d;
                r++
              ) {
                for (u = 0; e > u; ++u)
                  (k = a.get(r - 1, s - m + u)),
                    (i -= k),
                    (j -= k * k),
                    (k = a.get(r + d - 1, s - m + u)),
                    (i += k),
                    (j += k * k);
                (f = i / q),
                  (g = Math.sqrt((j - (i * i) / q) / q)),
                  g > h && (h = g),
                  b.set(r + l, s, f),
                  c.set(r + l, s, g);
              }
            }
            return h;
          },
          e = function (e, f, g, h, i, j) {
            var k,
              l,
              m,
              n = 0,
              o = Math.round(g / 2),
              p = Math.round(h / 2),
              q = o,
              r = e.width - o - 1,
              s = e.height - p - 1,
              t = p;
            (a = a || new mcv.Image(e.widt, e.height)),
              (b = b || new mcv.Image(e.width, e.height)),
              (m = d(e, a, b, g, h));
            var u = mcv.imgproc.minMaxLoc(e),
              v = u.min;
            u.max;
            c = c || new mcv.Image(e.width, e.height);
            var w, x, y;
            for (x = t; s >= x; x++) {
              for (w = 0; w <= e.width - g; w++) {
                if (
                  ((k = a.get(w + o, x)),
                  (l = b.get(w + o, x)),
                  (n = k + i * (l / m - 1) * (k - v)),
                  c.set(w + o, x, n),
                  0 === w)
                ) {
                  for (w = 0; q >= w; ++w) c.set(w, x, n);
                  if (x == t) for (y = 0; t > y; ++y) for (w = 0; q >= w; ++w) c.set(w, y, n);
                  if (x == s)
                    for (y = s + 1; y < e.height; ++y) for (w = 0; q >= w; ++w) c.set(w, y, n);
                }
                if (x == t) for (y = 0; t > y; ++y) c.set(w + o, y, n);
                if (x == s) for (y = s + 1; y < e.height; ++y) c.set(w + o, y, n);
              }
              for (w = r; w < e.width; ++w) c.set(w, x, n);
              if (x == t) for (y = 0; t > y; ++y) for (w = r; w < e.width; ++w) c.set(w, y, n);
              if (x == s)
                for (y = s + 1; y < e.height; ++y) for (w = r; w < e.width; ++w) c.set(w, y, n);
            }
            var z, A;
            for (A = 0; A < e.height; ++A)
              for (z = 0; z < e.width; ++z)
                e.get(z, A) >= c.get(z, A) ? f.set(z, A, 255) : f.set(z, A, 0);
          };
        return {
          apply: function (a, b) {
            var c = 0.5,
              d = Math.round((2 * a.height - 1) / 3),
              f = Math.round(a.width - 1 < d ? a.width - 1 : d);
            f > 100 && (f = d = 40);
            var g = new Uint8Array(new ArrayBuffer(a.width * a.height));
            (b.data = g), (b.width = a.width), (b.height = a.height), e(a, b, f, d, c, 128);
          },
        };
      })();
      a.sauvola = b;
    })(mcv),
    (function (a) {
      'use strict';
      var b = (function () {
        var a = function (a, b) {
          var c = a.data,
            d = b.data,
            e = a.width,
            f = 4 * e,
            g = c.length,
            h = 0,
            i = 0,
            j = 0;
          for (h = 0; g > h; h += f)
            for (i = 0; e > i; i += 5)
              (d[j] = d[j + 1] = d[j + 2] = c[h]), (d[j + 3] = 255), (j += 4), (h += 5);
          return b;
        };
        return {
          renderThumbnail: function (b, c, d, e, f) {
            c && b.putImageData(a(c, d), e, f);
          },
          renderU8Image: function (a, b, c) {
            null == c.cols && (c.cols = c.width), null == c.rows && (c.rows = c.height);
            for (
              var d = new Uint32Array(b.data.buffer), e = 255 << 24, f = c.cols * c.rows, g = 0;
              --f >= 0;

            )
              (g = c.data[f]), (d[f] = e | (g << 16) | (g << 8) | g);
            a.putImageData(b, 0, 0);
          },
          renderLines: function (a, b, c, d) {
            if (null != b && b.length > 0) {
              a.beginPath(), (a.strokeStyle = c), (a.lineWidth = d);
              for (var e = 0; e < b.length; e++)
                a.moveTo(b[e].p1.x, b[e].p1.y), a.lineTo(b[e].p2.x, b[e].p2.y);
              a.stroke();
            }
          },
          renderCorners: function (a, b, c) {
            if (null != b && b.length > 0)
              for (var d = 0; d < b.length; d++)
                a.beginPath(),
                  a.arc(b[d].x, b[d].y, 5, 0, 2 * Math.PI, !1),
                  (a.fillStyle = c),
                  a.fill(),
                  (a.lineWidth = 2),
                  (a.strokeStyle = '#003300'),
                  a.stroke();
          },
          renderContours: function (a, b, c, d) {
            if (null != b && b.length > 0)
              for (var e = 0; e < b.length; e++) {
                var f = b[e];
                if (null != f && f.length > 0) {
                  a.beginPath(), (a.strokeStyle = c), (a.lineWidth = d), a.moveTo(f[0].x, f[0].y);
                  for (var g = 1; g < f.length; ++g) a.lineTo(f[g].x, f[g].y);
                  a.closePath(), a.stroke();
                }
              }
          },
          renderText: function (a, b, c, d) {
            (a.fillStyle = 'green'), (a.font = 'bold 16px Arial'), a.fillText(d, b, c);
          },
        };
      })();
      a.debug = b;
    })(mcv),
    (function () {
      'use strict';
      var a = 'undefined' != typeof module && module.exports,
        b = 'undefined' != typeof Element && 'ALLOW_KEYBOARD_INPUT' in Element,
        c = (function () {
          for (
            var a,
              b = [
                [
                  'requestFullscreen',
                  'exitFullscreen',
                  'fullscreenElement',
                  'fullscreenEnabled',
                  'fullscreenchange',
                  'fullscreenerror',
                ],
                [
                  'webkitRequestFullscreen',
                  'webkitExitFullscreen',
                  'webkitFullscreenElement',
                  'webkitFullscreenEnabled',
                  'webkitfullscreenchange',
                  'webkitfullscreenerror',
                ],
                [
                  'webkitRequestFullScreen',
                  'webkitCancelFullScreen',
                  'webkitCurrentFullScreenElement',
                  'webkitCancelFullScreen',
                  'webkitfullscreenchange',
                  'webkitfullscreenerror',
                ],
                [
                  'mozRequestFullScreen',
                  'mozCancelFullScreen',
                  'mozFullScreenElement',
                  'mozFullScreenEnabled',
                  'mozfullscreenchange',
                  'mozfullscreenerror',
                ],
                [
                  'msRequestFullscreen',
                  'msExitFullscreen',
                  'msFullscreenElement',
                  'msFullscreenEnabled',
                  'MSFullscreenChange',
                  'MSFullscreenError',
                ],
              ],
              c = 0,
              d = b.length,
              e = {};
            d > c;
            c++
          )
            if (((a = b[c]), a && a[1] in document)) {
              for (c = 0; c < a.length; c++) e[b[0][c]] = a[c];
              return e;
            }
          return !1;
        })(),
        d = {
          request: function (a) {
            var d = c.requestFullscreen;
            (a = a || document.documentElement),
              /5\.1[\.\d]* Safari/.test(navigator.userAgent)
                ? a[d]()
                : a[d](b && Element.ALLOW_KEYBOARD_INPUT);
          },
          exit: function () {
            document[c.exitFullscreen]();
          },
          toggle: function (a) {
            this.isFullscreen ? this.exit() : this.request(a);
          },
          raw: c,
        };
      return c
        ? (Object.defineProperties(d, {
            isFullscreen: {
              get: function () {
                return Boolean(document[c.fullscreenElement]);
              },
            },
            element: {
              enumerable: !0,
              get: function () {
                return document[c.fullscreenElement];
              },
            },
            enabled: {
              enumerable: !0,
              get: function () {
                return Boolean(document[c.fullscreenEnabled]);
              },
            },
          }),
          void (a ? (module.exports = d) : (window.screenfull = d)))
        : void (a ? (module.exports = !1) : (window.screenfull = !1));
    })();
}
